/* ==========================================================================
   LED-Konfektionierung — Theme-Skripte
   Vanilla JS, keine Abhängigkeiten.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Header: mobile Navigation ---------- */
  /* ---------- Bestätigung nach dem Hinzufügen ---------- */
  var toastTimer = null;
  function zeigeToast(titel, sub) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    var titelEl = t.querySelector('[data-toast-title]');
    var subEl = t.querySelector('[data-toast-sub]');
    if (titelEl) titelEl.textContent = titel || 'Zum Warenkorb hinzugefügt';
    if (subEl) subEl.textContent = sub || '';
    t.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { t.classList.remove('is-visible'); }, 5200);
  }
  function initToast() {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    var close = t.querySelector('[data-toast-close]');
    if (close) close.addEventListener('click', function () { t.classList.remove('is-visible'); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') t.classList.remove('is-visible');
    });
  }

  /* ---------- Steuerung: direkt hinzufügen ohne Seitenwechsel ---------- */
  function initPicker() {
    $$('.cpicker form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var idEl = form.querySelector('input[name="id"]');
        var qtyEl = form.querySelector('input[name="quantity"]');
        if (!idEl) return;
        e.preventDefault();
        var btn = form.querySelector('.cpicker__add');
        if (btn) btn.disabled = true;

        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: idEl.value, quantity: Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1) }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () {
            if (btn) btn.disabled = false;
            zeigeToast('Steuerung hinzugefügt', 'Du kannst weiter einkaufen oder zur Kasse.');
          })
          .catch(function () {
            if (btn) btn.disabled = false;
            form.submit();
          });
      });
    });
  }

  function initHeader() {
    var toggle = $('[data-nav-toggle]');
    var nav = $('[data-nav]');
    if (!toggle || !nav) return;

    var scrim = $('[data-nav-scrim]');
    var closeBtn = $('[data-nav-close]');
    var lastFocus = null;

    function setNav(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('nav-open', open);

      if (scrim) {
        if (open) {
          scrim.hidden = false;
          requestAnimationFrame(function () { scrim.classList.add('is-visible'); });
        } else {
          scrim.classList.remove('is-visible');
          window.setTimeout(function () { scrim.hidden = true; }, 300);
        }
      }

      if (open) {
        lastFocus = document.activeElement;
        var first = nav.querySelector('a, button');
        if (first) first.focus({ preventScroll: true });
      } else if (lastFocus) {
        lastFocus.focus({ preventScroll: true });
      }
    }

    toggle.addEventListener('click', function () {
      setNav(!nav.classList.contains('is-open'));
    });

    nav.addEventListener('mouseleave', function () { nav.removeAttribute('data-zu'); });

    if (closeBtn) closeBtn.addEventListener('click', function () { setNav(false); });
    if (scrim) scrim.addEventListener('click', function () { setNav(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) setNav(false);
    });

    // Header beim Scrollen kompakter machen (sticky bleibt, wird aber flacher)
    var header = document.querySelector('.header');
    if (header) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          header.classList.toggle('is-scrolled', window.scrollY > 24);
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Klick auf einen Menüpunkt schließt das Menü.
       Besonders wichtig für Sprungmarken wie den Bandfinder (/#finder):
       Vorher blieb das Overlay offen über der Zielsektion liegen — das sah
       aus, als hätte der Klick nichts bewirkt. */
    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a || a.closest('[data-submenu-toggle]')) return;

      var href = a.getAttribute('href') || '';
      var hashPos = href.indexOf('#');
      var pfad = hashPos > -1 ? href.slice(0, hashPos) : '';

      // Sprungmarke auf derselben Seite (auch "/#finder" von der Startseite)
      var gleicheSeite = hashPos > -1 &&
        (pfad === '' || pfad === window.location.pathname || pfad === window.location.pathname.replace(/\/$/, ''));

      if (gleicheSeite) {
        e.preventDefault();
        var ziel = document.querySelector(href.slice(hashPos));
        setNav(false);

        /* Desktop-Dropdown hängt an :focus-within und [data-open]. Der
           angeklickte Link behält sonst den Fokus — das Menü bliebe sichtbar,
           obwohl der Sprung längst passiert ist. */
        $$('[data-submenu]').forEach(function (el) { el.removeAttribute('data-open'); });
        $$('[data-submenu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (a.blur) a.blur();
        if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
        // Hover über dem Menü würde das Dropdown sonst offen halten
        nav.setAttribute('data-zu', '');

        if (ziel) {
          // Erst schließen (body.nav-open blockiert das Scrollen), dann springen
          window.setTimeout(function () {
            var kopf = document.querySelector('.header');
            var abstand = (kopf ? kopf.getBoundingClientRect().height : 0) + 12;
            var y = ziel.getBoundingClientRect().top + window.scrollY - abstand;
            window.scrollTo({ top: y, behavior: 'smooth' });
            if (history.replaceState) history.replaceState(null, '', href.slice(hashPos));
          }, 180);
        }
        return;
      }

      // Normale Navigation: Overlay sofort schließen, damit es nicht nachhängt
      setNav(false);
    });

    // Untermenüs: auf Touch klappt der Pfeil auf, am Desktop öffnet Hover
    $$('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.closest('[data-submenu]');
        if (!item) return;
        var open = item.hasAttribute('data-open');
        $$('[data-submenu]').forEach(function (el) { el.removeAttribute('data-open'); });
        if (!open) item.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------- Produktgalerie ---------- */
  /* Technische Zeichnungen sind Dokumente, keine Fotos: im 16:9-Rahmen
     würden sie oben/unten beschnitten. Klassenwechsel schaltet auf contain. */
  function zeichnungMarkieren(main, thumb) {
    var rahmen = main.closest('.product__media');
    if (!rahmen) return;
    rahmen.classList.toggle('is-doc', !!(thumb && thumb.hasAttribute('data-doc')));
  }

  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var main = $('[data-gallery-main] img', gallery);
      $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          var src = thumb.getAttribute('data-src');
          if (src) main.setAttribute('src', src);
          /* Alt-Text mitziehen — bei Variantenbildern (2,4 GHz / Zigbee / WiFi)
             stand sonst immer das Motiv der ersten Variante im Markup. */
          var thumbBild = thumb.querySelector('img');
          if (thumbBild && thumbBild.alt) main.setAttribute('alt', thumbBild.alt);
          zeichnungMarkieren(main, thumb);
          $$('[data-gallery-thumb]', gallery).forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ---------- Mengen-Stepper ---------- */
  function initQty() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      $$('button', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(input.getAttribute('step') || '1', 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var max = parseInt(input.getAttribute('max') || '9999', 10);
          var dir = btn.getAttribute('data-qty-dir') === 'down' ? -1 : 1;
          var next = (parseInt(input.value, 10) || min) + dir * step;
          input.value = Math.min(max, Math.max(min, next));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Hilfsfunktionen ---------- */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function digits(value) {
    // Shopify-Optionen sind englisch formatiert ("22.22 cm"), deutsche Eingaben
    // nutzen Komma ("22,22 cm") und teils Tausenderpunkte ("1.234,5").
    // Deshalb den Punkt NUR entfernen, wenn ein Komma als Dezimaltrenner da ist —
    // sonst wird aus 22.22 die Zahl 2222.
    var s = String(value);
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    var m = s.match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }

  /* ---------- LED-Konfigurator ---------- */
  function initConfigurator(root) {
    var dataEl = $('[data-config-data]', root);
    var form = $('[data-cart-form]', root);
    if (!dataEl || !form) return;

    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // Liquid liefert höchstens 250 Varianten. Produkte mit mehreren
    // Lichtfarben × vielen Längen liegen darüber — dort steht die vollständige
    // Liste im Asset und wird hier nachgeladen, bevor der Konfigurator startet.
    // Dasselbe gilt für die Kabellängen (295 Schritte): Sie liegen im Asset,
    // weil Liquid sonst ab 1275 cm abschneidet.
    var kette = Promise.resolve();

    if (cfg.variantsUrl && cfg.handle && (cfg.variants || []).length >= 250) {
      kette = kette.then(function () {
        return fetch(cfg.variantsUrl, { cache: 'no-cache' })
          .then(function (r) { return r.json(); })
          .then(function (alle) {
            // Datei je Produkt enthält ein Array, die alte Sammeldatei ein Objekt
            var eintrag = Array.isArray(alle) ? { variants: alle } : (alle && alle[cfg.handle]);
            if (eintrag && eintrag.variants && eintrag.variants.length) cfg.variants = eintrag.variants;
          })
          .catch(function () { /* Asset fehlt — mit den 250 aus Liquid weiterarbeiten */ });
      });
    }

    if (cfg.cablesUrl) {
      kette = kette.then(function () {
        return fetch(cfg.cablesUrl, { cache: 'no-cache' })
          .then(function (r) { return r.json(); })
          .then(function (liste) { if (Array.isArray(liste) && liste.length) cfg.cables = liste; })
          .catch(function () { /* mit den Varianten aus Liquid weiterarbeiten */ });
      });
    }

    kette.then(function () { aufbau(root, form, cfg); });
  }

  function aufbau(root, form, cfg) {
    var variants = cfg.variants || [];
    if (!variants.length) return;
    var mediaByColor = cfg.mediaByColor || null;

    var optionPos = parseInt(cfg.lengthOptionIndex, 10) || 0;
    var key = 'option' + (optionPos + 1);
    var cutStep = parseFloat(cfg.cutStep) || 0;
    var minLength = parseFloat(cfg.minLength) || 0;
    var maxLength = parseFloat(cfg.maxLength) || 0;
    var selectedLength = parseFloat(cfg.preselectLength) || 0;
    var wattPerMeter = parseFloat(cfg.wattPerMeter) || 0;
    var currency = cfg.currency || 'EUR';

    // Längen aus den Varianten
    var lengths = [];
    var byLength = {};
    variants.forEach(function (v) {
      var len = digits(v[key]);
      if (len === null) return;
      if (!byLength[len]) { byLength[len] = []; lengths.push(len); }
      byLength[len].push(v);
    });
    lengths.sort(function (a, b) { return a - b; });
    if (!lengths.length) return;

    var minAvail = minLength || lengths[0];
    var maxAvail = maxLength || lengths[lengths.length - 1];
    lengths = lengths.filter(function (l) { return l >= minAvail && l <= maxAvail; });
    if (!lengths.length) return;

    if (!selectedLength || lengths.indexOf(selectedLength) === -1) {
      selectedLength = lengths[0];
    }

    var slider = $('[data-length-slider]', root);

    /* Maßband: Skala aus den echten Längengrenzen aufbauen */
    function baueSkala() {
      var ruler = slider && slider.closest('[data-ruler]');
      if (!ruler) return;
      var minCm = parseFloat(ruler.getAttribute('data-min-cm')) || 0;
      var maxCm = parseFloat(ruler.getAttribute('data-max-cm')) || 0;
      if (!(maxCm > minCm)) return;
      var maxM = maxCm / 100;
      /* Wie viele Meter-Marken passen? Rund 46 px je Beschriftung. */
      var breite = ruler.getBoundingClientRect().width || 320;
      var plaetze = Math.max(2, Math.min(8, Math.floor(breite / 46)));
      var stufen = [0.5, 1, 2, 5, 10, 20, 50];
      var stepM = stufen[stufen.length - 1];
      for (var i = 0; i < stufen.length; i++) {
        if (maxM / stufen[i] <= plaetze) { stepM = stufen[i]; break; }
      }
      var ticks = ruler.querySelector('[data-ruler-ticks]');
      var labels = ruler.querySelector('[data-ruler-labels]');
      if (!ticks || !labels) return;
      ticks.innerHTML = '';
      labels.innerHTML = '';

      var klein = (stepM * 100) / 5;          /* fünf kleine Striche je Meter-Marke */
      var start = Math.ceil(minCm / klein) * klein;
      for (var cm = start; cm <= maxCm + 0.01; cm += klein) {
        var pct = ((cm - minCm) / (maxCm - minCm)) * 100;
        var gross = Math.abs(cm % (stepM * 100)) < 0.01;
        var t = document.createElement('span');
        t.className = 'config__ruler-tick' + (gross ? ' config__ruler-tick--gross' : '');
        t.style.left = pct + '%';
        ticks.appendChild(t);
      }
      var erste = Math.ceil(minCm / 100 / stepM) * stepM || stepM;
      if (erste < stepM) erste = stepM;
      /* Labels mittig unter den Strich setzen und nur am Bandrand begrenzen.
         Vorher wurde das letzte Label rechtsbündig gesetzt — dadurch stand
         „10 m" sichtbar neben seinem Strich. */
      var bandPad = 13;                              /* LED-Band ist je Seite 13 px breiter */
      var lBox = labels.getBoundingClientRect().width || breite;
      for (var m = erste; m * 100 <= maxCm + 0.01; m += stepM) {
        var pm = ((m * 100 - minCm) / (maxCm - minCm)) * 100;
        if (pm < 0.5) continue;
        var l = document.createElement('span');
        l.className = 'config__ruler-label';
        l.textContent = m + ' m';
        labels.appendChild(l);
        var lw = l.offsetWidth || 20;
        var ziel = (pm / 100) * lBox - lw / 2;       /* Mitte auf den Strich */
        var minL = -bandPad;
        var maxL = lBox + bandPad - lw;
        if (ziel < minL) ziel = minL;
        if (ziel > maxL) ziel = maxL;
        l.style.left = (ziel / lBox) * 100 + '%';
      }
    }

    /* Füllstand: Anteil der gewählten Länge zwischen min und max */
    function setzeFuellung() {
      if (!slider) return;
      var min = parseFloat(slider.min) || 0;
      var max = parseFloat(slider.max) || 100;
      var v = parseFloat(slider.value) || 0;
      var anteil = max > min ? ((v - min) / (max - min)) : 0;
      anteil = Math.max(0, Math.min(1, anteil));
      var ruler = slider.closest('[data-ruler]');
      if (ruler) ruler.style.setProperty('--pr', anteil.toFixed(4));
      slider.style.setProperty('--p', (anteil * 100).toFixed(2) + '%');
      /* Screenreader sollen die echte Länge hören, nicht den Regler-Index. */
      if (selectedLength) {
        slider.setAttribute('aria-valuetext', String(selectedLength).replace('.', ',') + ' cm');
      }
    }
    var input = $('[data-length-input]', root);
    var totalOuts = $$('[data-total]', root);
    // Die Kaufleiste steht außerhalb des Konfigurators — ihren Preis separat einsammeln,
    // sonst bleibt er beim Ändern der Länge stehen.
    $$('[data-buybar] [data-total]').forEach(function (el) {
      if (totalOuts.indexOf(el) === -1) totalOuts.push(el);
    });
    var buybarMeta = $('[data-buybar-meta]');
    var meterOuts = $$('[data-meter-price]', root);
    var hintOuts = $$('[data-length-hint]', root);
    var variantInput = $('[data-variant-input]', root);
    var consent = $('[data-consent]', root);
    var submits = $$('[data-submit]', root);
    var submit = submits[0];   // Kaufleiste — trägt den Pflicht-Hinweis

    /* Beide Bestellknöpfe (Kaufleiste + Ende der Konfiguration) gleich halten */
    function setSubmit(disabled) {
      submits.forEach(function (s2) { s2.disabled = disabled; });
    }
    var submitHints = $$('[data-missing-hint]', root);
    var submitHint = submitHints[0];   // Kaufleiste

    // Zubehör
    // Netzteile nach Bandspannung: 24-V-Band → 24-V-Gruppe, 48-V-Band → 48-V-Gruppe.
    // Ohne Gruppen (ältere Seiten) greift die flache Liste als Rückfall.
    var spannung = String(cfg.voltage || '').replace(/[^0-9]/g, '').slice(0, 2);
    var psuQuelle = (cfg.psuGroups && cfg.psuGroups[spannung]) || cfg.psuVariants || [];
    var psuVariants = psuQuelle.slice().sort(function (a, b) { return a.w - b.w; });
    /* Kabeltyp nach Bandart: 2-polig (einfarbig), 3-polig (CCT), 4-polig (RGB),
       5-polig (RGB+W), 6-polig (RGB+CCT) */
    var KABEL_TYP = (function () {
      var t = String(cfg.controlType || 'Einfarbig').toLowerCase();
      if (t.indexOf('rgb') >= 0 && t.indexOf('cct') >= 0) return '6';
      if (t.indexOf('rgb') >= 0) return (t.indexOf('+w') >= 0 || t.indexOf('rgbw') >= 0) ? '5' : '4';
      if (t.indexOf('cct') >= 0) return '3';
      return '2';
    })();
    var KABEL_LABEL = {
      '2': '2-polig · 0,75 mm²', '3': '3-polig · 0,5 mm²', '4': '4-polig · 0,5 mm²',
      '5': '5-polig · 0,5 mm²', '6': '6-polig · 0,5 mm²'
    };
    function kabelListe() {
      return (cfg.cables || []).filter(function (c) {
        return !c.typ || String(c.typ) === KABEL_TYP;
      }).sort(function (a, b) { return a.cm - b.cm; });
    }
    var cables = kabelListe();
    var kabelTypEl = $('[data-cable-type]', root);
    if (kabelTypEl) kabelTypEl.textContent = KABEL_LABEL[KABEL_TYP] || '';
    var psuMode = null;      // bewusst kein Default: der Kunde muss wählen
    var cableCm = null;      // null = noch nicht gewählt (0 = "kein Kabel")
    var psuPick = null;
    var psuInfo = $('[data-psu-info]', root);

    // Weitere Optionen
    var otherPicks = {};
    $$('[data-option-group]', root).forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-option-group'), 10);
      otherPicks[pos] = null;
      $$('[data-option-value]', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          otherPicks[pos] = btn.getAttribute('data-option-value');
          $$('[data-option-value]', group).forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          update();
        });
      });
    });

    /* ---------- Kabellänge: Maßband 30–1000 cm in 5-cm-Schritten (max. 10 m) ---------- */
    var cableRuler = $('[data-cable-ruler]', root);
    /* Obergrenze kommt aus dem Markup (data-max-cm), nicht aus dem Skript:
       Deko-Light gibt 3 m vor, das Feld darf nicht mehr zulassen. */
    var KABEL_MAX = parseFloat((cableRuler && cableRuler.getAttribute('data-max-cm')) || 0) || 300;
    var cableSlider = $('[data-cable-slider]', root);
    var cableValueOut = $('[data-cable-value]', root);
    var cablePriceOut = $('[data-cable-price]', root);
    var cableHintOut = $('[data-cable-hint]', root);
    var cableNoneBtn = $('[data-cable="0"]', root);
    var cableField = $('[data-cable-field]', root);
    var cableInput = $('[data-cable-input]', root);

    function baueKabelSkala() {
      if (!cableRuler) return;
      var minC = parseFloat(cableRuler.getAttribute('data-min-cm')) || 30;
      var maxC = parseFloat(cableRuler.getAttribute('data-max-cm')) || 1000;
      var ticks = $('[data-ruler-ticks]', cableRuler);
      var labels = $('[data-ruler-labels]', cableRuler);
      if (!ticks || !labels) return;
      ticks.innerHTML = '';
      labels.innerHTML = '';

      /* Beschriftung so dicht wie möglich, aber ohne Überlappung:
         auf dem Desktop jeder Meter, auf dem Handy jeder zweite. */
      var breite = cableRuler.getBoundingClientRect().width || 320;
      var plaetze = Math.max(2, Math.min(10, Math.floor(breite / 46)));
      var maxM = maxC / 100;
      var stufen = [1, 2, 5, 10, 20, 50];
      var stepM = stufen[stufen.length - 1];
      for (var s = 0; s < stufen.length; s++) {
        if (maxM / stufen[s] <= plaetze) { stepM = stufen[s]; break; }
      }

      /* Hilfsstriche auf runden 25-cm-Werten — vorher begannen sie bei der
         Mindestlänge (30/55/80 …), was auf einem Maßband nichts ablesbar macht. */
      var klein = 25;
      var start = Math.ceil(minC / klein) * klein;
      for (var c = start; c <= maxC + 0.01; c += klein) {
        if (Math.abs(c % (stepM * 100)) < 0.01) continue;   /* dort steht der große Strich */
        var t = document.createElement('span');
        t.className = 'config__ruler-tick';
        t.style.left = (((c - minC) / (maxC - minC)) * 100) + '%';
        ticks.appendChild(t);
      }

      /* Große Striche + Beschriftung, mittig und am Rand begrenzt */
      var bandPad = 13;
      var lBox = labels.getBoundingClientRect().width || breite;
      for (var m = stepM; m * 100 <= maxC + 0.01; m += stepM) {
        var pm = ((m * 100 - minC) / (maxC - minC)) * 100;
        var gross = document.createElement('span');
        gross.className = 'config__ruler-tick config__ruler-tick--gross';
        gross.style.left = pm + '%';
        ticks.appendChild(gross);
        var l = document.createElement('span');
        l.className = 'config__ruler-label';
        l.textContent = m + ' m';
        labels.appendChild(l);
        var lw = l.offsetWidth || 20;
        var ziel = (pm / 100) * lBox - lw / 2;
        var minL = -bandPad;
        var maxL = lBox + bandPad - lw;
        if (ziel < minL) ziel = minL;
        if (ziel > maxL) ziel = maxL;
        l.style.left = (ziel / lBox) * 100 + '%';
      }
      setzeKabelFuellung();
    }

    function setzeKabelFuellung() {
      if (!cableRuler || !cableSlider) return;
      var min = parseFloat(cableSlider.min) || 0;
      var max = parseFloat(cableSlider.max) || 100;
      var v = parseFloat(cableSlider.value) || 0;
      var anteil = max > min ? (v - min) / (max - min) : 0;
      cableRuler.style.setProperty('--pr', Math.max(0, Math.min(1, anteil)).toFixed(4));
      if (cableSlider) {
        cableSlider.setAttribute('aria-valuetext',
          cableCm === null ? 'keine Auswahl' : (cableCm === 0 ? 'ohne Kabel' : cableCm + ' cm'));
      }
    }

    function zeigeKabel() {
      kabelEingabeZeigen();
      var cab = cablePrice();
      if (cableValueOut) {
        cableValueOut.textContent = cableCm === null ? '—'
          : (cableCm === 0 ? 'ohne Kabel' : String(cableCm).replace('.', ',') + ' cm');
      }
      if (cablePriceOut) cablePriceOut.textContent = cab ? money(cab.price, currency) : '';
      if (cableHintOut) {
        cableHintOut.textContent = cableCm === null
          ? 'Regler bewegen oder „Kein Kabel“ wählen — 30 cm bis 3 m in 5-cm-Schritten.'
          : '';
      }
      // Kopfzeile des Schritts mitführen (der Regler löst kein click-Event aus)
      var kabelKopf = $('[data-acc="cable"] [data-acc-value]', root);
      if (kabelKopf) {
        kabelKopf.textContent = cableCm === null ? ''
          : (cableCm === 0 ? 'ohne Kabel' : String(cableCm).replace('.', ',') + ' cm');
      }
      kabelModus(cableCm === 0 ? 'none' : (cableCm === null ? null : 'length'));
    }

    /* Zwei gleichrangige Wege: Länge wählen oder kein Kabel */
    function kabelModus(modus) {
      if (cableField) cableField.classList.toggle('is-active', modus === 'length');
      if (cableNoneBtn) cableNoneBtn.setAttribute('aria-pressed', modus === 'none' ? 'true' : 'false');
      if (cableRuler) cableRuler.classList.toggle('is-off', modus === 'none');
    }

    /* Tippen und Maßband müssen denselben Wert zeigen. Das Feld wird nur
       beschrieben, wenn der Cursor nicht drinsteht — sonst springt die
       Eingabe beim Tippen. */
    function kabelEingabeZeigen() {
      if (!cableInput) return;
      if (document.activeElement === cableInput) return;
      cableInput.value = (cableCm === null || cableCm === 0) ? '' : String(cableCm);
    }

    function kabelSetzen(cm) {
      cableCm = cm;
      if (cableSlider) cableSlider.value = String(Math.min(KABEL_MAX, Math.max(30, cm)));
      setzeKabelFuellung();
      kabelEingabeZeigen();
      zeigeKabel();
      update();
    }

    if (cableSlider) {
      baueKabelSkala();
      cableSlider.addEventListener('input', function () {
        cableCm = parseFloat(cableSlider.value) || 0;
        setzeKabelFuellung();
        zeigeKabel();
        update();
      });
    }
    if (cableInput) {
      /* Ziffern zulassen, alles andere verwerfen — auf dem Handy öffnet
         inputmode="numeric" die Zahlentastatur. */
      cableInput.addEventListener('input', function () {
        var roh = cableInput.value.replace(/[^0-9]/g, '');
        if (roh !== cableInput.value) cableInput.value = roh;
        var v = parseInt(roh, 10);
        if (!isNaN(v) && v >= 30 && v <= KABEL_MAX) {
          var gerundet = Math.round(v / 5) * 5;
          cableCm = gerundet;
          if (cableSlider) cableSlider.value = String(gerundet);
          setzeKabelFuellung();
          zeigeKabel();
          update();
        }
      });
      cableInput.addEventListener('change', function () {
        var v = parseInt(cableInput.value.replace(/[^0-9]/g, ''), 10);
        if (isNaN(v) || v < 30) v = 30;
        if (v > KABEL_MAX) v = KABEL_MAX;
        v = Math.round(v / 5) * 5;
        cableInput.value = String(v);
        kabelSetzen(v);
      });
    }
    if (cableNoneBtn) {
      cableNoneBtn.addEventListener('click', function () {
        cableCm = 0;
        zeigeKabel();
        update();
      });
    }
    zeigeKabel();

    /* ---------- Netzteil-Modus ---------- */
    $$('[data-psu]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        psuMode = btn.getAttribute('data-psu');
        $$('[data-psu]', root).forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        update();
      });
    });

    // Keine Vorauswahl: Lichtfarbe, Kabellänge und Netzteil muss der Kunde
    // selbst wählen. Ein vorgewähltes Feld führt sonst zu Bestellungen mit
    // der falschen Lichtfarbe oder ohne passendes Netzteil.
    function fehlendeWahl() {
      var fehlt = [];
      var farben = Object.keys(otherPicks);
      for (var i = 0; i < farben.length; i++) {
        if (!otherPicks[farben[i]]) {
          var gruppe = $('[data-option-group="' + farben[i] + '"]', root);
          var label = gruppe ? $('.config__label', gruppe) : null;
          fehlt.push(label ? label.textContent.trim() : 'Option');
        }
      }
      // Nur prüfen, was auf dieser Seite überhaupt zur Wahl steht — sonst
      // blockiert der Knopf bei Produkten ohne Kabel-/Netzteil-Auswahl für immer.
      if ($$('[data-cable]', root).length && cableCm === null) fehlt.push('Anschlusskabel');
      if ($$('[data-psu]', root).length && !psuMode) fehlt.push('Netzteil');
      return fehlt;
    }

    function findVariant() {
      var candidates = byLength[selectedLength] || [];
      var opKeys = Object.keys(otherPicks).map(function (k) { return parseInt(k, 10); });
      var match = candidates.filter(function (v) {
        for (var i = 0; i < opKeys.length; i++) {
          var picked = otherPicks[opKeys[i]];
          if (picked && v['option' + (opKeys[i] + 1)] !== picked) return false;
        }
        return true;
      });
      return (match.filter(function (v) { return v.available; })[0]) || match[0] || candidates[0];
    }

    /* ---------- Galerie an die gewählte Lichtfarbe anpassen ---------- */
    function syncGallery(variant) {
      if (!mediaByColor || !variant) return;
      var farben = Object.keys(otherPicks).map(function (k) { return parseInt(k, 10); });
      for (var i = 0; i < farben.length; i++) {
        var val = variant['option' + (farben[i] + 1)];
        var m = val ? mediaByColor[val] : null;
        if (m) {
          var main = document.querySelector('[data-gallery-main] img');
          if (main && m.src) {
            main.setAttribute('src', m.src);
            main.removeAttribute('srcset');
            main.setAttribute('alt', 'Lichtfarbe ' + val);
          }
          $$('[data-gallery-thumb]').forEach(function (t) {
            t.setAttribute('aria-current',
              t.getAttribute('data-media-color') === val ? 'true' : 'false');
          });
          return;
        }
      }
    }

    /* ---------- Netzteil berechnen ---------- */
    function calcPsu(lenCm) {
      if (!wattPerMeter || !psuVariants.length) return null;
      var bandWatt = wattPerMeter * (lenCm / 100);
      var need = bandWatt * 1.25;
      for (var i = 0; i < psuVariants.length; i++) {
        if (psuVariants[i].w >= need) {
          return { w: psuVariants[i].w, id: psuVariants[i].id, price: psuVariants[i].price,
                   band: bandWatt, need: need };
        }
      }
      return { w: null, band: bandWatt, need: need };
    }

    function cablePrice() {
      var liste = kabelListe();
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].cm === cableCm) return liste[i];
      }
      return null;
    }

    function stepFor(len) {
      if (!cutStep) return null;
      return Math.round(len / cutStep);
    }

    // Abschnitts-Marker: Amber = noch offen, Grün = hat einen Wert/Auswahl.
    function markGroups() {
      /* Der Accordion-Init unten lebt in einem eigenen Scope und kommt an
         diese Funktion nicht heran — deshalb der Haken am Element. */
      root.__markGroups = markGroups;
      $$('.config__group', root).forEach(function (g) {
        var hatAuswahl = !!g.querySelector('[aria-pressed="true"], .is-active');
        var hatWert = !!g.querySelector('input[type="range"], input[type="number"]');
        /* Steuerung/Fernbedienung sind Radio-Listen: „fertig" heißt hier,
           dass eine echte Option gewählt ist — nicht die leere Zeile. */
        var accName = g.getAttribute('data-acc');
        /* Vorbelegte Controller (Pflicht bei CCT/RGB) dürfen den Schritt nicht
           schon beim Laden abhaken — erst eine bewusste Wahl oder das
           Weitergehen aus dem Schritt zählt. */
        var beruehrt = g.getAttribute('data-touched') === '1';
        // Beim Kabel zählt nur eine bewusste Wahl — der Regler steht zwar
        // immer auf einem Wert, gewählt ist deshalb noch nichts.
        var istKabel = g.getAttribute('data-acc') === 'cable';
        var istGateway = g.getAttribute('data-acc') === 'gateway';
        var istRadio = accName === 'ctrl' || accName === 'remote';
        /* Kabel, Steuerung, Fernbedienung und Gateway sind beantwortet, sobald
           der Kunde etwas wählt oder den Schritt verlässt. „Ohne" ist eine
           gültige Antwort; eine bloße Vorbelegung zählt nicht. */
        var istFertig;
        if (istKabel) istFertig = cableCm !== null;
        else if (istGateway) istFertig = beruehrt && !g.hidden && !g.open;
        else if (istRadio) istFertig = beruehrt && !g.open;
        else istFertig = hatAuswahl || hatWert;
        g.classList.toggle('is-done', istFertig);
        if (g.classList.contains('config__acc')) {
          /* Offen = hier arbeitet der Kunde gerade, auch wenn schon ein Wert
             drinsteht. Erst beim Weiterschalten wird daraus „erledigt“. */
          g.setAttribute('data-state', g.open ? 'current' : (istFertig ? 'done' : 'todo'));
        }
      });

      /* Gibt es keinen offenen Schritt, ist der erste offene der aktuelle —
         sonst stünde die Kette ohne markierten Punkt da. */
      var accs = $$('.config__acc', root).filter(function (g) { return !g.hidden; });
      var hatAktuell = accs.some(function (g) { return g.getAttribute('data-state') === 'current'; });
      if (!hatAktuell) {
        for (var ai = 0; ai < accs.length; ai++) {
          if (accs[ai].getAttribute('data-state') === 'todo') {
            accs[ai].setAttribute('data-state', 'current');
            break;
          }
        }
      }
      /* Alles beantwortet: dann sind alle Punkte gefüllt, auch der offene
         letzte — sonst bliebe zum Schluss ein Ring statt eines Hakens. */
      if (accs.length && accs.every(function (g) { return g.classList.contains('is-done'); })) {
        accs.forEach(function (g) { g.setAttribute('data-state', 'done'); });
      }
      // Die Zusammenfassung ist erst „fertig", wenn der Zuschnitt bestätigt ist.
      var summary = $('[data-summary-group]', root);
      if (summary) summary.classList.toggle('is-done', !!(consent && consent.checked));

      // Fortschritt: vier Pflichtschritte (Länge, Lichtfarbe, Kabel, Netzteil).
      // Die Linie sitzt am unteren Rand der Kaufleiste und wird bei 4/4 grün.
      var progressFill = $('[data-progress-fill]', root);
      var progressLabel = $('[data-progress-label]', root);
      if (progressFill) {
        // Nur die Gruppen zählen, die es auf DIESEM Produkt gibt: CCT- und
        // RGB-Bänder haben keine Lichtfarben-Auswahl, manche Produkte kein
        // Kabel oder Netzteil. Eine feste 4 hätte dort nie 100 % erreicht.
        var gruppen = $$('.config__group', root).filter(function (g) {
          return !g.hasAttribute('data-summary-group');
        });
        var gesamt = gruppen.length || 1;
        var schritte = gruppen.filter(function (g) { return g.classList.contains('is-done'); }).length;
        progressFill.style.width = Math.min(100, (schritte / gesamt) * 100) + '%';
        /* „Fertig" erst, wenn auch der Zuschnitt bestätigt ist — sonst stand
           dort fertig, während der Knopf wegen der Pflicht-Checkbox sperrte. */
        var zuschnittOk = !!(consent && consent.checked);
        progressFill.classList.toggle('is-complete', schritte >= gesamt);
        if (progressLabel) {
          progressLabel.textContent = schritte >= gesamt
            ? (zuschnittOk ? 'fertig · ' : 'Zuschnitt bestätigen · ') + schritte + '/' + gesamt
            : 'Schritte ' + schritte + '/' + gesamt;
        }
      }
    }

    /* Netzteile in der Zubehör-Box: nur die, die für die gewählte Länge
       reichen (Länge × W/m plus 25 % Reserve). Das kleinste ausreichende
       wird als empfohlen markiert. */
    var zbox = document.querySelector('[data-zubehoer]');
    var zboxNeed = zbox && zbox.querySelector('[data-zbox-need]');
    function syncZubehoer() {
      if (!zbox) return;
      var need = (selectedLength / 100) * wattPerMeter * 1.25;
      var karten = Array.prototype.slice.call(zbox.querySelectorAll('[data-zbox-karte][data-watt-produkt]'));
      karten.sort(function (a, b) {
        return (+a.getAttribute('data-watt-produkt') || 0) - (+b.getAttribute('data-watt-produkt') || 0);
      });
      /* Kleinstes Netzteil zuerst — sonst steht die Empfehlung unten außerhalb
         des Bildes und der Kunde sieht nur die großen Trafos. */
      var raster = karten.length ? karten[0].parentNode : null;
      if (raster && !raster.__sortiert) {
        karten.forEach(function (k) { raster.appendChild(k); });
        raster.__sortiert = true;
      }
      var empfohlen = null;
      karten.forEach(function (k) {
        var w = +k.getAttribute('data-watt-produkt') || 0;
        var zuKlein = w > 0 && w < need;
        k.classList.toggle('is-zu-klein', zuKlein);
        var st = k.querySelector('[data-zbox-state]');
        if (st) st.hidden = !zuKlein;
        var btn = k.querySelector('button');
        if (btn) btn.disabled = zuKlein;
        if (!zuKlein && !empfohlen) empfohlen = k;
      });
      karten.forEach(function (k) {
        var ist = k === empfohlen;
        k.classList.toggle('is-empfohlen', ist);
        var b = k.querySelector('[data-zbox-badge]');
        if (b) b.hidden = !ist;
      });
      if (zboxNeed) {
        zboxNeed.textContent = !need ? ''
          : (empfohlen ? ' · ' + Math.ceil(need) + ' W Netzteil nötig' : ' · kein passendes Netzteil im Sortiment');
      }
    }

    function update() {
      syncZubehoer();
      markGroups();
      // Pflichtauswahl ermitteln — die Sperre des Knopfes wird weiter unten
      // EINMAL gesetzt, gemeinsam mit der Zuschnitt-Bestätigung. Zwei Stellen,
      // die beide submit.disabled schreiben, überschreiben sich sonst.
      var fehlt = fehlendeWahl();
      var bereit = fehlt.length === 0;

      var variant = findVariant();
      if (!variant) return;
      /* Galerie folgt der Lichtfarbe sofort, nicht erst wenn alle Schritte
         fertig sind — sonst bleibt beim Umschalten das falsche Foto stehen. */
      syncGallery(variant);

      if (slider) slider.value = String(selectedLength);
      if (input) input.value = String(selectedLength).replace('.', ',');
      /* Kopfzeile des Längen-Schritts kommt aus derselben Quelle wie das Feld —
         so steht dort nach dem Rasten auf die Schnittmarke 450,9 und nicht 450. */
      var laengeOut = root.querySelector('[data-acc="length"] [data-acc-value]');
      if (laengeOut && input) laengeOut.textContent = String(input.value).replace('.', ',') + ' cm';
      if (variantInput) variantInput.value = variant.id;

      // Netzteil
      var psu = calcPsu(selectedLength);
      psuPick = (psuMode === 'auto') ? psu : null;

      // Preise
      var bandPrice = variant.price;
      var cab = cablePrice();
      var cableCost = cab ? cab.price : 0;
      var psuCost = (psuPick && psuPick.price) ? psuPick.price : 0;
      // Steuerung und Fernbedienung: Auswahl in der Kaufspalte. Sie gehört in
      // dieselbe Bestellung — Preis in der Summe, Position im Warenkorb.
      var ctrlWahl = document.querySelector('input[name="ls-ctrl"]:checked');
      var remoteWahl = document.querySelector('input[name="ls-remote"]:checked');
      var ctrlPreis = ctrlWahl ? (Number(ctrlWahl.getAttribute('data-price')) || 0) : 0;
      var remotePreis = remoteWahl ? (Number(remoteWahl.getAttribute('data-price')) || 0) : 0;
      // Gateway zählt nur, wenn der Schritt sichtbar ist und eine echte Wahl steht.
      var gwSchritt = document.getElementById('gateway');
      var gwWahl = document.querySelector('input[name="ls-gw"]:checked');
      var gwPreis = (gwSchritt && !gwSchritt.hidden && gwWahl) ? (Number(gwWahl.getAttribute('data-price')) || 0) : 0;

      var total = bandPrice + cableCost + psuCost + ctrlPreis + remotePreis + gwPreis;

      totalOuts.forEach(function (el) { el.textContent = money(total, currency); });

      /* Die Setup-Sektion auf der Produktseite rechnet mit denselben Werten.
         Ereignis statt geteiltem Zustand: sie liegt außerhalb dieses Closures. */
      document.dispatchEvent(new CustomEvent('led:setup', { detail: {
        cm: selectedLength,
        cableCm: cableCm,
        cablePrice: cableCost,
        cableLabel: cab ? cab.label : '',
        watt: wattPerMeter,
        voltage: cfg.voltage
      }}));

      if (buybarMeta) {
        var teile = [];
        if (selectedLength) teile.push(String(selectedLength).replace('.', ',') + ' cm');
        if (cableCm === 0) teile.push('ohne Kabel');
        else if (cableCm) teile.push(String(cableCm).replace('.', ',') + ' cm Kabel');
        if (psuPick && psuPick.w) teile.push(psuPick.w + ' W');
        buybarMeta.textContent = teile.join(' · ');
      }

      if (selectedLength) {
        var perMeter = Math.round(bandPrice / (selectedLength / 100));
        /* „/m" steht im Markup — hier nur der Betrag, sonst steht es doppelt. */
        meterOuts.forEach(function (el) { el.textContent = money(perMeter, currency); });
      }

      var segs = stepFor(selectedLength);
      var hintParts = [String(selectedLength).replace('.', ',') + ' cm Gesamtlänge'];
      if (segs) hintParts.push(segs + ' Schnittsegmente');
      if (cutStep) hintParts.push('Schnittteilung ' + (cfg.cutStepLabel || (cutStep + ' cm')));
      // 24-V-Bänder: max. 10 m je Einspeisung, darüber hinaus neuer Einspeisepunkt
      var ist24v = cfg.voltage && String(cfg.voltage).indexOf('24') === 0;
      if (ist24v && selectedLength >= 900) {
        hintParts.push('10-m-Grenze je Einspeisung — der nächste Abschnitt braucht eine neue Einspeisung');
      } else if (ist24v && selectedLength > 500) {
        hintParts.push('ab 5 m beidseitige Einspeisung empfohlen');
      }
      hintOuts.forEach(function (el) { el.textContent = hintParts.join(' · '); });


      // Netzteil-Erklärung
      if (psuInfo) {
        if (psuMode === 'none') {
          // Kunde hat ein eigenes Netzteil: Er braucht trotzdem die Zahlen,
          // sonst weiß er nicht, welche Leistung sein Trafo liefern muss.
          if (psu && psu.w) {
            psuInfo.innerHTML = '<div class="notice notice--warn" style="margin-top:12px">' +
                '<span class="notice__icon">!</span><div>' +
                '<strong>Kein Netzteil im Lieferumfang.</strong> Du hast „Ohne Netzteil“ gewählt — ' +
                'das LED-Band kommt ohne Trafo. Ein eigenes ' + (spannung || '24') + '-V-DC-Netzteil musst du selbst stellen.' +
                '</div></div>' +
              '<div class="config__summary" style="margin-top:12px">' +
              '<div><div class="config__summary-label">Dein eigenes Netzteil</div>' +
              '<div class="product-card__meta" style="margin:0">' +
                (selectedLength / 100).toFixed(1).replace('.', ',') + ' m × ' +
                String(wattPerMeter).replace('.', ',') + ' W/m = ' +
                psu.band.toFixed(1).replace('.', ',') + ' W · mit 25 % Reserve ' +
                Math.ceil(psu.need) + ' W' +
              '</div></div>' +
              '<div class="config__summary-total">' + Math.ceil(psu.need) + ' W</div></div>' +
              '<div class="config__hint" style="margin-top:8px">Du brauchst ein <strong>' + (spannung || '24') + '-V-DC-Netzteil' +
              ' mit mindestens ' + Math.ceil(psu.need) + ' W</strong>. Die Reserve von 25 % deckt ' +
              'Anlaufstrom und lange Zuleitungen ab.</div>';
          } else {
            psuInfo.innerHTML = '<div class="notice notice--warn" style="margin-top:12px">' +
              '<span class="notice__icon">!</span><div>Ohne passendes Netzteil leuchtet das LED-Band nicht. ' +
              'Betriebsspannung 24 V DC.</div></div>';
          }
        } else if (!psu) {
          psuInfo.innerHTML = '';
        } else if (psu.w) {
          psuInfo.innerHTML = '<div class="config__summary" style="margin-top:12px">' +
            '<div><div class="config__summary-label">Passendes Netzteil</div>' +
            '<div class="product-card__meta" style="margin:0">' +
              (selectedLength / 100).toFixed(1).replace('.', ',') + ' m × ' +
              String(wattPerMeter).replace('.', ',') + ' W/m = ' +
              psu.band.toFixed(1).replace('.', ',') + ' W · mit Reserve ' +
              Math.ceil(psu.need) + ' W' +
            '</div></div>' +
            '<div class="config__summary-total">' + psu.w + ' W</div></div>';
        } else {
          psuInfo.innerHTML = '<div class="notice notice--warn" style="margin-top:12px">' +
            '<span class="notice__icon">!</span><div>Für diese Länge ist eine Sonderlösung nötig. ' +
            'Wir melden uns nach der Bestellung mit der Aufteilung.</div></div>';
        }
      }

      // Zusammenfassung
      var sum = {
        band: $('[data-sum-band]', root),
        bandMeta: $('[data-sum-band-meta]', root),
        cableRow: $('[data-sum-cable-row]', root),
        cable: $('[data-sum-cable]', root),
        cableMeta: $('[data-sum-cable-meta]', root),
        psuRow: $('[data-sum-psu-row]', root),
        psu: $('[data-sum-psu]', root),
        psuMeta: $('[data-sum-psu-meta]', root),
        ctrlRow: $('[data-sum-ctrl-row]', root),
        ctrl: $('[data-sum-ctrl]', root),
        ctrlMeta: $('[data-sum-ctrl-meta]', root),
        remoteRow: $('[data-sum-remote-row]', root),
        remote: $('[data-sum-remote]', root),
        remoteMeta: $('[data-sum-remote-meta]', root),
        gwRow: $('[data-sum-gw-row]', root),
        gw: $('[data-sum-gw]', root),
        gwMeta: $('[data-sum-gw-meta]', root)
      };

      if (sum.band) sum.band.textContent = money(bandPrice, currency);
      if (sum.bandMeta) {
        sum.bandMeta.textContent = (selectedLength / 100).toFixed(1).replace('.', ',') + ' m' +
          (otherPicks[1] ? ' · ' + otherPicks[1] : '') +
          (otherPicks[2] ? ' · ' + otherPicks[2] : '');
      }

      if (sum.cableRow) {
        if (cab) {
          sum.cableRow.style.display = '';
          if (sum.cable) sum.cable.textContent = money(cab.price, currency);
          if (sum.cableMeta) sum.cableMeta.textContent = cab.label || (String(cab.cm).replace('.', ',') + ' cm');
        } else {
          sum.cableRow.style.display = 'none';
        }
      }

      if (sum.psuRow) {
        if (psuMode === 'auto' && psu && psu.w) {
          sum.psuRow.style.display = '';
          if (sum.psu) sum.psu.textContent = money(psu.price, currency);
          if (sum.psuMeta) sum.psuMeta.textContent = psu.w + ' W';
        } else {
          sum.psuRow.style.display = 'none';
        }
      }

      if (sum.ctrlRow) {
        /* Nur zeigen, wenn wirklich eine Steuerung gewählt ist — „Ohne" hat
           value="" und darf keine 0,00-€-Zeile in die Summe schreiben. */
        if (ctrlWahl && ctrlWahl.value) {
          sum.ctrlRow.style.display = '';
          if (sum.ctrl) sum.ctrl.textContent = money(ctrlPreis, currency);
          if (sum.ctrlMeta) sum.ctrlMeta.textContent = ctrlWahl.getAttribute('data-title') || '';
        } else {
          sum.ctrlRow.style.display = 'none';
        }
      }
      if (sum.remoteRow) {
        if (remoteWahl && remoteWahl.value) {
          sum.remoteRow.style.display = '';
          if (sum.remote) sum.remote.textContent = money(remotePreis, currency);
          if (sum.remoteMeta) sum.remoteMeta.textContent = remoteWahl.getAttribute('data-title') || '';
        } else {
          sum.remoteRow.style.display = 'none';
        }
      }
      /* Gateway: nur eine echte Wahl (nicht „Ich habe schon eins“) und nur,
         solange der Schritt sichtbar ist — sonst steht er nicht in der Summe,
         obwohl er im Warenkorb landet. */
      if (sum.gwRow) {
        var gwAktiv = gwSchritt && !gwSchritt.hidden && gwWahl && gwWahl.value;
        if (gwAktiv) {
          sum.gwRow.style.display = '';
          if (sum.gw) sum.gw.textContent = money(gwPreis, currency);
          if (sum.gwMeta) sum.gwMeta.textContent = (gwWahl.getAttribute('data-title') || '').replace(/^Gateway\s*·\s*/, '');
        } else {
          sum.gwRow.style.display = 'none';
        }
      }


      // Hidden-Felder
      var propsWrap = $('[data-props]', root);
      if (propsWrap) propsWrap.innerHTML = '';
      var props = { 'Länge': selectedLength + ' cm' };
      if (cutStep) props['Schnittteilung'] = cfg.cutStepLabel || (cutStep + ' cm');
      if (cab) props['Anschlusskabel'] = cab.label;
      if (psuMode === 'auto' && psu && psu.w) props['Netzteil'] = psu.w + ' W';

      Object.keys(props).forEach(function (name) {
        if (!propsWrap) return;
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'properties[' + name + ']';
        i.value = props[name];
        propsWrap.appendChild(i);
      });

      // Knopf und Hinweis: Pflichtauswahl + Zuschnitt-Bestätigung zusammen
      var consentFehlt = !!(consent && !consent.checked);
      var blocked = !bereit || consentFehlt || !variant.available;
      submits.forEach(function (s2) {
        s2.disabled = blocked;
        s2.classList.toggle('btn--locked', blocked);
        s2.textContent = !variant.available
          ? (s2.getAttribute('data-label-soldout') || 'Nicht verfügbar')
          : (s2.getAttribute('data-label') || 'In den Warenkorb');
      });
      // Checkbox hervorheben, sobald sie der EINZIGE offene Punkt ist —
      // dann sieht der Kunde sofort, dass nur noch der Haken fehlt.
      if (consent) {
        var box = consent.closest('.consent');
        if (box) box.classList.toggle('is-missing', consentFehlt && bereit);
      }

      var offen = [];
      if (!bereit) offen.push('Noch offen: ' + fehlt.join(' · '));
      else if (consentFehlt) offen.push('Bitte noch das Zuschnitt-Kästchen anhaken.');
      submitHints.forEach(function (h) {
        h.hidden = offen.length === 0;
        h.textContent = offen.join(' ');
      });
    }

    // Slider — immer in Zentimetern, nie über den Varianten-Index.
    // Der Index wäre nur bei einem exakt gleichmäßigen Längenraster linear zur
    // Länge; bei Lücken oder Altlängen wandert der Knopf aus der Maßbandskala
    // heraus (genau das war bei den COB-Bändern der Fall). step="any" hält den
    // Knopf an der Zentimeterposition, danach rastet er auf die echte Länge.
    if (slider) {
      slider.min = String(minAvail);
      slider.max = String(maxAvail);
      slider.step = 'any';
      slider.value = String(selectedLength);
      slider.addEventListener('input', function () {
        selectedLength = snap(parseFloat(slider.value));
        slider.value = String(selectedLength);
        setzeFuellung();
        update();
      });
      /* Pfeiltasten einen Schnittschritt weiter — mit step="any" würde der
         Browser sonst rund ein Prozent der Gesamtlänge pro Tastendruck springen. */
      slider.addEventListener('keydown', function (e) {
        var i = lengths.indexOf(selectedLength);
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') i = Math.min(lengths.length - 1, i + 1);
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') i = Math.max(0, i - 1);
        else if (e.key === 'Home') i = 0;
        else if (e.key === 'End') i = lengths.length - 1;
        else return;
        e.preventDefault();
        selectedLength = lengths[i];
        slider.value = String(selectedLength);
        setzeFuellung();
        update();
      });
    }

    baueSkala();
    setzeFuellung();

    function snap(val) {
      var best = lengths[0], bestDiff = Infinity;
      lengths.forEach(function (l) {
        var d = Math.abs(l - val);
        if (d < bestDiff) { bestDiff = d; best = l; }
      });
      return best;
    }

    if (input) {
      input.addEventListener('change', function () {
        var val = parseFloat(String(input.value).replace(',', '.'));
        if (isNaN(val)) { update(); setzeFuellung(); return; }
        selectedLength = snap(val);
        update();
        setzeFuellung();
      });
    }

    if (consent) consent.addEventListener('change', update);

    /* Steuerung und Fernbedienung sind eigene Schritte im Konfigurator.
       Jede Änderung aktualisiert die Beschriftung des Schritts und die Summe. */
    function setzeCtrlLabels() {
      [['ls-ctrl', '[data-ctrl-value]'], ['ls-remote', '[data-remote-value]']].forEach(function (paar) {
        var wahl = document.querySelector('input[name="' + paar[0] + '"]:checked');
        var ziel = $(paar[1], root) || document.querySelector(paar[1]);
        if (!ziel) return;
        var gewaehlt = !!(wahl && wahl.value);
        ziel.textContent = gewaehlt ? (wahl.getAttribute('data-title') || 'Gewählt') : 'Ohne';
        var gruppe = ziel.closest('.config__acc');
        if (gruppe) gruppe.classList.toggle('is-done', gewaehlt);
      });
    }
    setzeCtrlLabels();

    /* Gateway nur zeigen, wenn der gewählte Controller eines braucht.
       Zigbee → Zigbee-Gateway, 2,4 GHz → 2,4-GHz-Gateway, WiFi → gar keins.
       Ein vorhandenes Hue-/IKEA-Gateway ist immer die kostenlose Option. */
    function gwAktualisieren() {
      var step = document.getElementById('gateway');
      if (!step) return;
      var ctrl = document.querySelector('input[name="ls-ctrl"]:checked');
      var proto = ctrl ? (ctrl.getAttribute('data-proto') || '') : '';
      var noetig = proto === 'zigbee' || proto === 'rf';
      var leer = step.querySelector('input[name="ls-gw"][value=""]');
      var opts = step.querySelectorAll('[data-gw-need]');
      var ziel = step.querySelector('[data-gw-value]');

      step.hidden = !noetig;
      if (!noetig) {
        if (leer) leer.checked = true;
        if (ziel) ziel.textContent = 'Nicht nötig';
        step.classList.remove('is-done');
        step.open = false;
        var cfg = step.closest('[data-led-config]');
        if (cfg && typeof cfg.__markGroups === 'function') cfg.__markGroups();
        return;
      }
      var cfg2 = step.closest('[data-led-config]');
      if (cfg2 && typeof cfg2.__markGroups === 'function') cfg2.__markGroups();

      opts.forEach(function (el) {
        var passt = el.getAttribute('data-gw-need') === proto;
        el.hidden = !passt;
        var inp = el.querySelector('input');
        if (!passt && inp && inp.checked) {
          if (leer) leer.checked = true;
        }
        if (passt && inp && ziel) ziel.setAttribute('data-gw-titel', inp.getAttribute('data-title') || '');
      });

      var hint = step.querySelector('[data-gw-hint]');
      if (hint) hint.textContent = proto === 'zigbee'
        ? 'Für App und Sprachsteuerung brauchst du ein Zigbee-Gateway. Dein Hue-, IKEA- oder Echo-Hub übernimmt das auch — dann brauchst du keins.'
        : 'Für App und Sprachsteuerung brauchst du ein 2,4-GHz-Gateway. Nur mit Fernbedienung geht es ohne.';

      var meta = step.querySelector('[data-gw-meta]');
      if (meta) meta.textContent = proto === 'zigbee'
        ? 'Hue, IKEA TRADFRI oder Echo Plus — der Controller koppelt direkt'
        : 'Ein vorhandenes 2,4-GHz-Gateway von MiBoxer oder Mi-Light';

      var wahl = step.querySelector('input[name="ls-gw"]:checked');
      var echt = !!(wahl && wahl.value);
      if (ziel) ziel.textContent = echt ? (wahl.getAttribute('data-title') || 'Gewählt') : (proto === 'zigbee' ? 'Vorhanden / später' : 'Ohne');
      step.classList.toggle('is-done', echt);
    }
    gwAktualisieren();

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches) return;
      if (e.target.matches('input[name="ls-ctrl"], input[name="ls-gw"]')) gwAktualisieren();
    });

    /* Sprungmarke auf einen Schritt (z. B. #steuerung): Schritt aufklappen,
       sonst landet der Kunde vor einer zugeklappten Zeile. */
    function oeffneZiel() {
      var h = location.hash;
      if (!h || h.length < 2) return;
      var z = null;
      try { z = document.querySelector(h); } catch (err) { return; }
      if (z && z.tagName === 'DETAILS') {
        z.open = true;
        /* theme.css scrollt weich; beim Sprung auf einen Schritt soll die
           Überschrift direkt unter dem Header stehen — darum hart springen. */
        window.requestAnimationFrame(function () {
          var y = z.getBoundingClientRect().top + window.scrollY - 96;
          window.scrollTo({ top: Math.max(0, y), behavior: 'instant' });
        });
      }
    }
    oeffneZiel();
    window.addEventListener('hashchange', oeffneZiel);

    $$('input[name="ls-ctrl"], input[name="ls-remote"], input[name="ls-gw"]').forEach(function (el) {
      el.addEventListener('change', function () { setzeCtrlLabels(); gwAktualisieren(); update(); });
    });

    /* ---------- Warenkorb: LED-Band + Kabel + Netzteil in einem Schritt ---------- */
    form.addEventListener('submit', function (e) {
      // Doppelte Absicherung: der Button ist gesperrt, aber falls das
      // Formular anders abgeschickt wird, hier erneut prüfen.
      var fehlt = fehlendeWahl();
      if (fehlt.length) {
        e.preventDefault();
        if (submitHint) {
          submitHint.hidden = false;
          submitHint.textContent = '⚠ Bitte noch wählen: ' + fehlt.join(' · ');
        }
        setSubmit(true);
        return;
      }

      var variant = findVariant();
      if (!variant) return;

      var qtyEl = $('input[name="quantity"]', form);
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;

      var items = [{
        id: variant.id,
        quantity: qty,
        properties: buildProps()
      }];

      var cab = cablePrice();
      if (cab) items.push({ id: cab.id, quantity: qty });
      /* Netzteil, Steuerung und Gateway stehen jetzt in der Zubehör-Box und
         werden dort einzeln hinzugelegt — nicht mehr mit dem Band zusammen. */

      if (qty > 1) {
        items.forEach(function (it) { if (it.properties) it.properties['Stück'] = String(qty); });
      }

      if (!items.length) return;

      e.preventDefault();
      setSubmit(true);

      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          setSubmit(false);
          zeigeToast('Zum Warenkorb hinzugefügt', 'Du kannst weiter einkaufen oder die Steuerung wählen.');
        })
        .catch(function () {
          // Fallback: normales Formular, nur das LED-Band
          setSubmit(false);
          form.submit();
        });
    });

    function buildProps() {
      var p = { 'Länge': String(selectedLength).replace('.', ',') + ' cm' };
      if (cutStep) p['Schnittteilung'] = (typeof cfg !== 'undefined' && cfg.cutStepLabel) || (cutStep + ' cm');
      return p;
    }

    /* Übergabe aus dem Bandfinder: ?laenge=400 setzt den Regler auf die
       nächstliegende bestellbare Länge. */
    (function laengeAusUrl() {
      var m = /[?&]laenge=([\d.,]+)/.exec(window.location.search);
      if (!m) return;
      var cm = parseFloat(String(m[1]).replace(',', '.'));
      if (!(cm > 0)) return;
      var best = null;
      lengths.forEach(function (l) {
        if (best === null || Math.abs(l - cm) < Math.abs(best - cm)) best = l;
      });
      if (best !== null) {
        selectedLength = best;
        if (slider) slider.value = String(best);
      }
    })();

    /* ?farbe=2700K wählt die passende Lichtfarben-Kachel, bevor der erste
       Preis berechnet wird. */
    (function farbeAusUrl() {
      var m = /[?&]farbe=([^&]+)/.exec(window.location.search);
      if (!m) return;
      var wert = decodeURIComponent(m[1]).replace(/\+/g, ' ').toLowerCase().replace(/\s+/g, '');
      var ziel = null;
      $$('[data-option-value]', root).forEach(function (btn) {
        if (ziel) return;
        var v = String(btn.getAttribute('data-option-value') || '').toLowerCase().replace(/\s+/g, '');
        if (v === wert) ziel = btn;
      });
      if (ziel) ziel.click();
    })();

    update();
  }

  /* ---------- Scroll-Reveal ----------
     Elemente bleiben immer sichtbar; .is-in startet nur die Einblendung.
     Zwei Wege parallel, damit es in jeder Umgebung greift: IntersectionObserver
     und ein Scroll-Fallback über getBoundingClientRect. */
  function initReveal() {
    if (window.LED_MOTION) return; // GSAP (motion.js) übernimmt die Einblendung
    var targets = $$('.section-head, .card, .usp, .step-card, .iwt, .faq, .step-card__num, .catcard, .tool, .lstep, .tip, .newsletter, .cta, .lhero__card');
    if (!targets.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var done = [];
    function show(el, i) {
      if (el.dataset.revealed) return;
      el.dataset.revealed = '1';
      if (i !== undefined) el.style.animationDelay = (i % 4) * 60 + 'ms';
      el.classList.add('is-in');
      // Sicherheitsnetz: die Klasse nach Ablauf wieder entfernen. Hängt die
      // Animation (Hintergrund-Tab, Energiesparen, kein Compositor-Tick),
      // bliebe das Element sonst auf dem Startwert der Animation stehen.
      window.setTimeout(function () {
        el.classList.remove('is-in');
        el.style.animationDelay = '';
      }, 1400);
      done.push(el);
    }

    var observer = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            show(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -5% 0px', threshold: 0.03 })
      : null;

    targets.forEach(function (el) {
      if (observer) observer.observe(el);
    });

    // Fallback: beim Scrollen prüfen (greift, wenn der Observer nicht feuert).
    // Nur noch offene Elemente werden gemessen, und sobald alle erschienen sind,
    // hängt sich der Listener ab — sonst läuft bei jedem Frame ein Layout-Read
    // über alle Karten und Überschriften.
    var offen = targets.slice();
    var ticking = false;
    function check() {
      ticking = false;
      if (!offen.length) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = offen.length - 1; i >= 0; i--) {
        var el = offen[i];
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.96 && r.bottom > 0) {
          show(el, i);
          offen.splice(i, 1);
        }
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Beim Init steht das Layout oft noch nicht (Bilder ohne Höhe) — deshalb
    // nach dem Load und ein zweites Mal kurz danach prüfen.
    window.addEventListener('load', check);
    check();
    window.setTimeout(check, 350);
    window.setTimeout(check, 1200);
  }

  /* ---------- Standard-Varianten ----------
     Gilt für Produkte ohne Längen-Konfigurator (z.B. Aluprofile mit der
     Auswahl „ohne / mit Abdeckung"). Das Formular sendet ausschließlich die
     versteckte Varianten-ID — ohne dieses Skript bleibt sie auf der ersten
     Variante stehen und der Kunde bestellt die falsche Ausführung. */
  function initStandardVariants() {
    var daten = $('[data-standard-variants]');
    if (!daten) return;
    var varianten;
    try { varianten = JSON.parse(daten.textContent); } catch (e) { return; }
    var selects = $$('select[data-option-index]');
    if (!selects.length) return;

    var form = daten.closest('form') || document;
    var idFeld = $('[data-variant-input]', form);
    var preise = $$('[data-total]');
    var submit = $('[data-submit]', form);
    var fmt;
    try {
      fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      fmt = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' €'; } };
    }

    function passende() {
      var werte = selects.map(function (s) { return s.value; });
      return varianten.filter(function (v) {
        return werte.every(function (w, i) { return v.options[i] === w; });
      })[0];
    }

    function update() {
      var v = passende();
      if (!v) return;
      if (idFeld) idFeld.value = v.id;
      preise.forEach(function (el) { el.textContent = fmt.format(v.price / 100); });
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available
          ? (submit.getAttribute('data-label') || 'In den Warenkorb')
          : (submit.getAttribute('data-label-soldout') || 'Ausverkauft');
      }
      // Galerie auf das Variantenbild ziehen: „Mit Milk Cover" zeigt das
      // Profil mit aufgesetzter Abdeckung, „Ohne" das offene Profil.
      if (v.mediaId) {
        var thumb = document.querySelector('[data-gallery-thumb][data-media-id="' + v.mediaId + '"]');
        var main = $('[data-gallery-main] img');
        if (thumb && main) {
          var src = thumb.getAttribute('data-src');
          if (src) main.setAttribute('src', src);
          zeichnungMarkieren(main, thumb);
          $$('[data-gallery-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        }
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState(null, '', u.toString());
      } catch (e) {}
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  /* ---------- Init ---------- */
  /* ---------- Licht-Slider: blendet zwei Aufnahmen über ---------- */
  function initLightSlider() {
    $$('[data-light-stage]').forEach(function (stage) {
      var img = $('[data-light-image]', stage);
      var badge = $('[data-light-badge]', stage);
      var range = stage.parentElement ? stage.parentElement.querySelector('[data-light-range]') : null;
      if (!img || !range) return;

      var wrap = stage.closest('.lightslider');

      function setze(w) {
        if (typeof w !== 'number') w = parseInt(range.value, 10);
        if (isNaN(w)) w = 0;
        w = Math.max(0, Math.min(100, w));

        stage.style.setProperty('--light-level', (w / 100).toFixed(2));
        range.style.setProperty('--fill', w + '%');
        range.value = String(w);

        if (badge) {
          badge.textContent = w === 0 ? 'aus' : (w === 100 ? 'an' : w + ' %');
          badge.classList.toggle('lightslider__badge--aus', w === 0);
        }
        range.setAttribute('aria-valuetext',
          w === 0 ? 'Licht aus' : (w === 100 ? 'Licht an' : w + ' Prozent'));
      }

      range.addEventListener('input', setze);

      setze(parseInt(range.value, 10) || 0);

      // Überblendung erst nach dem ersten Frame — sonst animiert der Startwert mit
      setTimeout(function () { if (wrap) wrap.classList.add('is-live'); }, 60);
    });
  }


  /* ---------- In den Warenkorb ohne Seitenwechsel ----------
     Fängt alle Formulare mit /cart/add ab, legt per AJAX in den Korb
     und zeigt eine Bestätigung. Der Kunde bleibt auf der Seite und kann
     weiter konfigurieren, Steuerung wählen oder Zubehör dazunehmen. */
  function initAjaxCart() {
    var toast = null;

    function baueToast() {
      if (toast) return toast;
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<span class="cart-toast__icon">' + '\u2713' + '</span>' +
        '<span class="cart-toast__text" data-toast-text></span>' +
        '<a class="cart-toast__link" href="/cart">Zum Warenkorb</a>' +
        '<button class="cart-toast__close" type="button" aria-label="Hinweis schließen">&times;</button>';
      toast.querySelector('.cart-toast__close').addEventListener('click', function () {
        toast.classList.remove('is-visible');
      });
      document.body.appendChild(toast);
      return toast;
    }

    function zeige(text) {
      var t = baueToast();
      t.querySelector('[data-toast-text]').textContent = text;
      t.classList.add('is-visible');
      clearTimeout(t.__timer);
      t.__timer = setTimeout(function () { t.classList.remove('is-visible'); }, 5000);
    }

    function aktualisiereZaehler() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (korb) {
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = korb.item_count;
            el.hidden = korb.item_count === 0;
          });
        })
        .catch(function () {});
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      /* Der Konfigurator hat das Absenden schon übernommen (LED-Band + Kabel +
         Netzteil als JSON). Ohne diese Sperre lief zusätzlich dieser Handler
         und schickte das Formular ein zweites Mal — das LED-Band landete doppelt
         im Korb. */
      if (e.defaultPrevented) return;
      e.preventDefault();

      var btn = form.querySelector('button[type=submit]');
      var alt = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '\u2026'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, data: d }; });
        })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Konnte nicht hinzugefügt werden');
          zeige(res.data.product_title + ' hinzugefügt');
          aktualisiereZaehler();
        })
        .catch(function (err) {
          zeige('Fehler: ' + err.message);
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = alt; }
        });
    });
  }

  function init() {
    initHeader();
    initGallery();
    initQty();
    initReveal();
    initStandardVariants();
    initLightSlider();
    initAjaxCart();
    initToast();
    initPicker();
    $$('[data-led-config]').forEach(initConfigurator);

    /* Sprungmarke nach dem Laden ausführen.
       Der Browser scrollt zu #finder oft nicht, weil das Ziel beim ersten
       Layout noch nicht existiert — dann landet man nach dem Klick aus einem
       anderen Menüpunkt oben auf der Startseite. */
    function springeZurMarke() {
      if (!window.location.hash || window.location.hash.length < 2) return;
      var ziel = null;
      try { ziel = document.querySelector(window.location.hash); } catch (e) { return; }
      if (!ziel) return;
      var kopf = document.querySelector('.header');
      var y = ziel.getBoundingClientRect().top + window.scrollY
            - ((kopf ? kopf.getBoundingClientRect().height : 0) + 12);
      window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
    }
    springeZurMarke();
    // Bilder und Schriften können das Layout danach noch verschieben
    window.addEventListener('load', function () { window.setTimeout(springeZurMarke, 60); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---------- Produktfinder (Startseite) ----------
   Vier Fragen (plus Weißton bei RGB+W), ein Produkt.

   Die Rohdaten der Produkte sind unsauber: das Metafeld control_type steht
   bei den 48-V-Bändern auf "Einfarbig", obwohl sie RGB bzw. CCT können, und
   die Kelvin-Liste ist nur bei Produkten mit Option "Lichtfarbe" gefüllt.
   Deshalb werden Typ und Lichtfarben hier aus control_type, color_temp,
   Optionswerten UND Titel normalisiert — sonst fällt ein Drittel des
   Sortiments aus der Suche. */
(function () {
  var abschnitt = document.querySelector('.finder');
  if (!abschnitt) return;

  /* Die Produktdaten (41 KB) liegen nicht mehr im HTML: Sie werden geladen,
     sobald der Finder in Sichtweite kommt. */
  var gestartet = false;
  function starte(daten) {
    if (!daten || !daten.length) return;
    gestartet = true;
    var hinweis = abschnitt.querySelector('.finder__fehler');
    if (hinweis) hinweis.remove();

  if ('IntersectionObserver' in window) {
    var sicht = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) {
          abschnitt.classList.add('is-visible');
          sicht.disconnect();
        }
      });
    }, { threshold: 0.12 });
    sicht.observe(abschnitt);
    setTimeout(function () {
      if (!abschnitt.classList.contains('is-visible')) abschnitt.classList.add('is-visible');
    }, 1500);
  } else {
    abschnitt.classList.add('is-visible');
  }

  var ort = null, laenge = null, genau = null, licht = null, stark = null, weiss = null;
  var altsOffen = false; /* Alternativenliste aufgeklappt? */
  var letztesProdukt = null;
  var offen = 1;         /* welcher Schritt gerade aufgeklappt ist */
  var letzterOffen = 1;

  var result = abschnitt.querySelector('[data-finder-result]');
  var elTitel = abschnitt.querySelector('[data-finder-title]');
  var elText = abschnitt.querySelector('[data-finder-text]');
  var elImg = abschnitt.querySelector('[data-finder-img]');
  var elPreis = abschnitt.querySelector('[data-finder-price]');
  var elPreisLabel = abschnitt.querySelector('[data-finder-price-label]');
  var elLink = abschnitt.querySelector('[data-finder-link]');
  var elFacts = abschnitt.querySelector('[data-finder-facts]');
  var elLight = abschnitt.querySelector('[data-finder-light]');
  var elAlts = abschnitt.querySelector('[data-finder-alts]');
  var elAltsList = abschnitt.querySelector('[data-finder-alts-list]');
  var elAltsToggle = abschnitt.querySelector('[data-finder-alts-toggle]');
  var elProgress = abschnitt.querySelector('[data-finder-progress]');
  var elNum = abschnitt.querySelector('[data-finder-step-num]');
  var elState = abschnitt.querySelector('[data-finder-progress-state]');

  /* Alle vierstelligen Zahlen aus color_temp, Optionswerten und Titel */
  function kelvinVon(p) {
    var roh = [p.ct, p.kelvin, p.title].join(' ');
    var treffer = [];
    roh.replace(/(^|\D)(\d{4})(?!\d)/g, function (m, vor, zahl) { treffer.push(zahl); return m; });
    var out = [];
    treffer.forEach(function (n) { if (out.indexOf(n) === -1) out.push(n); });
    return out;
  }

  function typVon(p) {
    var meta = String(p.typ || '').toUpperCase();
    var ct = String(p.ct || '').toUpperCase().replace(/\s+/g, '');
    var titel = String(p.title || '').toUpperCase();
    var rgb = meta.indexOf('RGB') > -1 || ct.indexOf('RGB') > -1 || titel.indexOf('RGB') > -1;
    var cct = meta.indexOf('CCT') > -1 || titel.indexOf('CCT') > -1 || /\d{4}-\d{4}K/.test(ct);
    if (rgb) {
      var weissKanal = ct.indexOf('+') > -1 || titel.indexOf('RGB+') > -1 || /\b\d{4}\b/.test(ct);
      return weissKanal ? 'RGBW' : 'RGB';
    }
    if (cct) return 'CCT';
    return 'EINFARBIG';
  }

  function voltVon(p) {
    var v = String(p.volt == null ? '24' : p.volt).replace(/[^\d]/g, '');
    return v || '24';
  }

  function serieVon(p) {
    return String(p.title || '').replace(/^LED (COB|SMD) /i, '').split(' · ')[0].trim();
  }
  function istLongRun(p) { return /long[\s-]*run/i.test(serieVon(p)); }

  /* Die Wunschlänge entscheidet über die Spannung:
       bis 5 m   → 24 V
       über 5 m  → 48 V, ersatzweise ein 24-V-Langlaufband
       über 10 m → nur 48 V (mehr geht nicht an einer Einspeisung) */
  function voltPlan() {
    if (!laenge) return null;
    if (laenge <= 5) return { listen: ['24'], text: '24 V' };
    var plan = { listen: ['48'], text: '48 V' };
    if (laenge <= 10) plan.listen.push('24lr');
    return plan;
  }
  function voltPasst(p, plan) {
    if (!plan) return true;
    var v = voltVon(p);
    for (var i = 0; i < plan.listen.length; i++) {
      var k = plan.listen[i];
      if (k === '24lr') { if (v === '24' && istLongRun(p)) return true; }
      else if (v === k) return true;
    }
    return false;
  }
  function voltRang(p, plan) {
    if (!plan) return 0;
    var v = voltVon(p);
    if (v === plan.listen[0]) return 0;
    if (plan.listen.indexOf('24lr') > -1 && v === '24' && istLongRun(p)) return 0;
    return 1;
  }

  /* Schnittraster: Ein Band lässt sich nur in Stufen seiner Teilung fertigen.
     zuschnitt() sagt, welche Länge dabei herauskommt und wie weit sie von der
     Wunschlänge abweicht. Nur damit lässt sich ehrlich „exakt" versprechen. */
  function zuschnitt(p, cm) {
    var cut = Number(p.cut || 0), min = Number(p.min || 0), max = Number(p.max || 0);
    if (!cut || !cm) return null;
    var n = Math.round(cm / cut);
    var ist = Math.round(n * cut * 100) / 100;
    if (min && ist < min - 0.001) {
      n = Math.ceil(min / cut);
      ist = Math.round(n * cut * 100) / 100;
    }
    if (max && ist > max + 0.001) return { moeglich: false, ist: null, diff: null };
    return { moeglich: true, ist: ist, diff: Math.round((ist - cm) * 100) / 100 };
  }
  function zuschnittPasst(p, cm, wie) {
    var z = zuschnitt(p, cm);
    if (!z || !z.moeglich) return false;
    /* „exakt" heißt auf den Millimeter: Nur wenn das Raster die Wunschlänge
       wirklich trifft, darf das Band als exakt gelten. Alles andere gehört
       in die Toleranz-Auswahl, sonst versprechen wir eine Länge, die wir
       nicht liefern. */
    return Math.abs(z.diff) <= (wie === 'exakt' ? 0.1 : 5);
  }

  /* Helligkeitsstufen als Ziel-Watt: das nächstliegende Band gewinnt. */
  var STARK_ZIEL = { dezent: 10, ausgewogen: 15, kraeftig: 20 };
  function wattZiel(stark) {
    return STARK_ZIEL[stark] == null ? 15 : STARK_ZIEL[stark];
  }
  function laengeText(n) { return String(n).replace('.', ',') + ' m'; }
  function cmText(n) { return String(Math.round(n * 10) / 10).replace('.', ',') + ' cm'; }
  function zuschnittFact(p) {
    if (!laenge) return '';
    var z = zuschnitt(p, laenge * 100);
    if (!z || !z.moeglich) return '';
    return 'Zuschnitt ' + cmText(z.ist) + (Math.abs(z.diff) < 0.1 ? '' : ' (' + abweichungText(z.diff) + ')');
  }
  function zuschnittText(cm) { return cm <= 100 ? cmText(cm) : laengeText(Math.round(cm) / 100); }
  function abweichungText(diff) {
    var d = Math.abs(Math.round(diff * 10) / 10);
    if (d < 0.1) return 'genau';
    return cmText(d) + (diff > 0 ? ' länger' : ' kürzer');
  }

  /* Welche Weißtöne gibt es bei RGB+W tatsächlich? */
  function markiereWeiss() {
    var vorhanden = {};
    var plan = voltPlan();
    daten.forEach(function (p) {
      if (typVon(p) === 'RGBW' && (!ort || ipKlasse(p) === ort) && voltPasst(p, plan)) {
        kelvinVon(p).forEach(function (k) { vorhanden[k] = true; });
      }
    });
    abschnitt.querySelectorAll('[data-finder-weiss]').forEach(function (b) {
      var k = b.getAttribute('data-finder-weiss');
      var fehlt = !vorhanden[k];
      b.classList.toggle('is-unavailable', fehlt);
      var alt = b.querySelector('.finder__opt-note');
      if (alt && fehlt && !alt.getAttribute('data-orig')) {
        alt.setAttribute('data-orig', alt.textContent);
        alt.textContent = alt.textContent + ' · derzeit nicht lieferbar';
      } else if (alt && !fehlt && alt.getAttribute('data-orig')) {
        alt.textContent = alt.getAttribute('data-orig');
        alt.removeAttribute('data-orig');
      }
    });
  }

  /* Lichtfarben, die es in dieser Kombination nicht gibt, werden ausgegraut
     und mit einem klaren Grund beschriftet — niemand klickt ins Leere. */
  function markiereLicht() {
    var plan = voltPlan();
    var buttons = abschnitt.querySelectorAll('[data-finder-licht]');
    if (!buttons.length) return;
    buttons.forEach(function (b) {
      var key = b.getAttribute('data-finder-licht');
      var da = !ort || !laenge || daten.some(function (p) {
        return passt(p, { ort: ort, plan: plan, licht: key, weiss: null });
      });
      b.classList.toggle('is-unavailable', !da);
      b.setAttribute('aria-disabled', da ? 'false' : 'true');
      if (grund) b.setAttribute('title', grund); else b.removeAttribute('title');
      var note = b.querySelector('.finder__opt-note');
      /* Grund benennen, nicht nur ausgrauen: liegt es am Schnittraster, an der
         Spannung oder an der Schutzart? */
      var grund = '';
      if (!da && key === 'rgbcct') {
        grund = 'Führen wir nicht ab Lager — das CCT-Band kann alle Weißtöne';
      } else if (!da) {
        var mitToleranz = !!(laenge && genau === 'exakt') && daten.some(function (p) {
          return ipKlasse(p) === ort && voltPasst(p, plan) &&
            passt(p, { ort: ort, plan: plan, licht: key, ohneLaenge: true }) &&
            zuschnittPasst(p, laenge * 100, 'toleranz');
        });
        var ohnePlan = daten.some(function (p) {
          return ipKlasse(p) === ort && passt(p, { ort: ort, plan: null, licht: key, ohneLaenge: true });
        });
        if (mitToleranz) {
          grund = 'Trifft ' + laengeText(laenge) + ' nicht exakt — mit ±5 cm lieferbar';
        } else if (!ohnePlan) {
          grund = ort === 'ip67' ? 'Für Bad und Außen nicht in IP67 verfügbar' : 'Für den Wohnraum nicht als IP20 verfügbar';
        } else {
          grund = 'Für ' + laengeText(laenge) + ' nicht als ' + plan.text + '-Band verfügbar';
        }
      }
      if (note) {
        if (!da) {
          if (!note.getAttribute('data-orig')) note.setAttribute('data-orig', note.textContent);
          note.textContent = grund;
        } else if (note.getAttribute('data-orig')) {
          note.textContent = note.getAttribute('data-orig');
          note.removeAttribute('data-orig');
        }
      }
      if (grund) b.setAttribute('data-grund', grund); else b.removeAttribute('data-grund');
      if (!da && b.getAttribute('aria-pressed') === 'true') {
        b.setAttribute('aria-pressed', 'false');
        if (licht === key) { licht = null; weiss = null; }
      }
    });
    /* Steht ohnehin kein Band zur Wahl, genügt der eine Hinweis über der Liste —
       dann nicht sechsmal denselben Raster-Satz wiederholen. */
    if (!abschnitt.querySelector('[data-finder-licht]:not(.is-unavailable)')) {
      abschnitt.querySelectorAll('[data-finder-licht].is-unavailable').forEach(function (b) {
        var g = b.getAttribute('data-grund') || '';
        var note = b.querySelector('.finder__opt-note');
        if (note && g.indexOf('Trifft') === 0) note.textContent = 'Nicht exakt lieferbar';
      });
    }
  }

  /* Wenn in Schritt 3 keine einzige Lichtfarbe übrig bleibt, darf der Kunde
     nicht vor einer grauen Wand stehen — dort steht dann derselbe Ausweg. */
  function zeigeLeerWarnung() {
    var box = abschnitt.querySelector('[data-finder-leer-warnung]');
    if (!box) return;
    var frei = abschnitt.querySelectorAll('[data-finder-licht]:not(.is-unavailable)').length;
    var zeigen = !!(ort && laenge && genau && !frei && !abschnitt.querySelector('[data-finder-step="3"]').hidden);
    box.hidden = !zeigen;
    if (!zeigen) return;
    if (toleranzKachel && genau !== 'toleranz') toleranzKachel.classList.add('is-empfohlen');
    var text = abschnitt.querySelector('[data-finder-leer-text]');
    var btn = abschnitt.querySelector('[data-finder-leer-toleranz]');
    if (text) {
      text.textContent = genau === 'exakt'
        ? 'Für ' + laengeText(laenge) + ' exakt haben wir in dieser Kombination kein Band. Mit ±5 cm wird die Auswahl größer.'
        : 'Für ' + laengeText(laenge) + ' haben wir in dieser Kombination kein Band. Ändere die Länge oder den Einsatzort.';
    }
    if (btn) btn.hidden = genau !== 'exakt';
  }
  abschnitt.querySelectorAll('[data-finder-leer-toleranz]').forEach(function (b) {
    b.addEventListener('click', function () {
      setzeGenau('toleranz'); markiereLicht(); markiereWeiss(); zeige();
    });
  });

  function waehle(el) {
    var gruppe = el.parentElement;
    gruppe.querySelectorAll('[aria-pressed="true"]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    el.setAttribute('aria-pressed', 'true');
  }

  function ipWert(p) {
    var n = parseInt(String(p.ip || 'IP20').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 20 : n;
  }

  /* Schutzart streng: Wohnraum heißt IP20, Bad und Außen heißt IP67.
     IP44 und IP65 sind weder das eine noch das andere (nicht untertauchbar)
     und werden für Bad und Außen bewusst nicht angeboten. */
  function ipKlasse(p) {
    var n = parseInt(String(p.ip || '').replace(/[^0-9]/g, ''), 10);
    if (isNaN(n)) return 'ip20';
    if (n >= 67) return 'ip67';
    if (n <= 20) return 'ip20';
    return 'zwischen';
  }

  function passt(p, o) {
    if (o.plan && !voltPasst(p, o.plan)) return false;
    if (ipKlasse(p) !== o.ort) return false;
    /* Länge und Genauigkeit gelten immer, auch bei der Prüfung der Lichtfarben. */
    if (!o.ohneLaenge && laenge && !zuschnittPasst(p, laenge * 100, o.genau || genau)) return false;
    var typ = typVon(p);
    if (o.licht === 'cct') return typ === 'CCT';
    /* RGB+CCT: Farbe plus ein Weißton, der den ganzen Bereich kann */
    if (o.licht === 'rgbcct') {
      if (typ !== 'RGBW') return false;
      var kc = kelvinVon(p);
      return kc.indexOf('2700') > -1 && kc.indexOf('6500') > -1;
    }
    if (o.licht === 'rgb') return typ === 'RGB' || typ === 'RGBW';
    if (o.licht === 'rgbw') {
      if (typ !== 'RGBW') return false;
      return !o.weiss || kelvinVon(p).indexOf(o.weiss) > -1;
    }
    if (typ !== 'EINFARBIG') return false;
    /* Extra Warm (2700) und Warmweiß (3000) sind getrennte Stufen —
       die exakte Kelvin-Zahl entscheidet. */
    /* Tageslichtweiß: 6000 K ist ebenfalls Tageslicht */
    if (o.licht === '6500') {
      var kd = kelvinVon(p);
      return kd.indexOf('6500') > -1 || kd.indexOf('6000') > -1;
    }
    return kelvinVon(p).indexOf(o.licht) > -1;
  }

  function liste(o) {
    var t = daten.filter(function (p) { return passt(p, o); });
    var ziel = wattZiel(o.stark);
    t.sort(function (a, b) {
      /* Erst die passende Spannung, dann die exakte Lichtfarbe, dann die Helligkeit. */
      var rang = voltRang(a, o.plan) - voltRang(b, o.plan);
      if (rang) return rang;
      if (laenge) {
        var za = zuschnitt(a, laenge * 100), zb = zuschnitt(b, laenge * 100);
        var da2 = za && za.moeglich ? Math.abs(za.diff) : 999;
        var db2 = zb && zb.moeglich ? Math.abs(zb.diff) : 999;
        if (da2 !== db2) return da2 - db2;
      }
      if (/^\d{4}$/.test(String(o.licht || ''))) {
        var ka2 = kelvinVon(a).indexOf(o.licht) > -1 ? 0 : 1;
        var kb2 = kelvinVon(b).indexOf(o.licht) > -1 ? 0 : 1;
        if (ka2 !== kb2) return ka2 - kb2;
      }
      if (o.ort === 'ip67') {
        var ia = ipWert(a), ib = ipWert(b);
        if (ia !== ib) return ib - ia;
      }
      var da = Math.abs((a.watt || ziel) - ziel), db = Math.abs((b.watt || ziel) - ziel);
      if (da !== db) return da - db;
      return (b.watt || 0) - (a.watt || 0);
    });
    return t;
  }

  function suche(o) {
    var t = liste(o);
    return t.length ? t[0] : null;
  }

  function finde() {
    var plan = voltPlan();
    var quelle = { ort: ort, licht: licht, weiss: weiss, stark: stark, plan: plan, genau: genau };
    var p = suche(quelle);
    var hinweis = null;

    /* Kein Band trifft die Länge exakt → das nächstliegende innerhalb ±5 cm
       anbieten und die Abweichung benennen, statt den Kunden ohne Ergebnis
       stehen zu lassen. */
    if (!p && genau === 'exakt' && laenge) {
      var mitToleranz = { ort: ort, licht: licht, weiss: weiss, stark: stark, plan: plan, genau: 'toleranz' };
      p = suche(mitToleranz);
      if (p) {
        quelle = mitToleranz;
        var z0 = zuschnitt(p, laenge * 100);
        hinweis = 'Kein Band trifft ' + laengeText(laenge) + ' exakt. Dieses kommt auf ' +
          zuschnittText(z0.ist) + ' — ' + abweichungText(z0.diff) + '. Sag uns Bescheid, wenn es genauer sein muss.';
      }
    }

    /* Für diese Länge gibt es in der Kombination kein Band der Wunschspannung
       → andere Spannung anbieten, klar benannt. */
    if (!p && plan) {
      var ohnePlan = { ort: ort, licht: licht, weiss: weiss, stark: stark, plan: null };
      p = suche(ohnePlan);
      if (p) {
        quelle = ohnePlan;
        var v = voltVon(p);
        hinweis = laenge > 5
          ? 'Für ' + laengeText(laenge) + ' gibt es in dieser Kombination kein 48-V-Band. Dieses Band läuft mit ' + v + ' V — über 10 m brauchst du einen zweiten Einspeisepunkt.'
          : 'Diese Kombination gibt es nur mit ' + v + ' V. Dafür ist ein ' + v + '-V-Netzteil nötig.';
      }
    }

    /* RGB+CCT gibt es ab Lager nicht: erst das CCT-Band (alle Weißtöne),
       dann RGB+W, dann reines RGB. */
    if (!p && licht === 'rgbcct') {
      var cctStufen = [
        { ort: ort, licht: 'cct', weiss: null, stark: stark, plan: plan },
        { ort: ort, licht: 'cct', weiss: null, stark: stark, plan: null },
        { ort: ort, licht: 'rgbw', weiss: null, stark: stark, plan: null },
        { ort: ort, licht: 'rgb', weiss: null, stark: stark, plan: null }
      ];
      for (var ci = 0; ci < cctStufen.length && !p; ci++) {
        p = suche(cctStufen[ci]);
        if (p) quelle = cctStufen[ci];
      }
    }

    /* Weißton nicht lieferbar → RGB+W ohne Weißfilter, dann anderes Netz, dann reines RGB */
    if (!p && licht === 'rgbw' && weiss) {
      var stufen = [
        { ort: ort, licht: 'rgbw', weiss: null, stark: stark, plan: plan },
        { ort: ort, licht: 'rgbw', weiss: null, stark: stark, plan: null },
        { ort: ort, licht: 'rgb', weiss: null, stark: stark, plan: null }
      ];
      for (var i = 0; i < stufen.length && !p; i++) {
        p = suche(stufen[i]);
        if (p) quelle = stufen[i];
      }
    }

    var weitere = [];
    if (p) {
      weitere = liste(quelle).filter(function (x) { return x.handle !== p.handle; });
    }
    return { produkt: p, hinweis: hinweis, weitere: weitere };
  }

  /* Kombinationen, die kein LED-Band exakt abdeckt — ehrlich benennen */
  var naeherung = {
    rgbcct: 'RGB+CCT führen wir ab Lager noch nicht. Das CCT-Band kann alle Weißtöne von 2700 bis 6500 K — Farben brauchen zusätzlich ein RGB-Band.'
  };

  function fortschritt() {
    if (!elProgress) return;
    var brauchtWeissF = (licht === 'rgbw');
    /* Reihenfolge der Fragen; „Weiß“ entfällt ohne RGBW */
    var reihenfolge = brauchtWeissF ? [1, 2, 3, 4, 5] : [1, 2, 3, 5];
    var werte = { 1: !!ort, 2: !!laenge && !!genau, 3: !!licht, 4: !!weiss, 5: !!stark };
    var gesamt = reihenfolge.length;
    var erledigt = 0;
    var aktuell = null;

    reihenfolge.forEach(function (n) {
      if (werte[n]) { erledigt++; }
      else if (!aktuell) { aktuell = n; }
    });

    /* Die Schritte selbst tragen den Fortschritt: Nummer füllen, Linie
       darunter wächst. „Weiß“ (4) fällt ohne RGBW weg und wird nicht
       mitgezählt, damit die Nummern 1–4 lückenlos bleiben. */
    var schrittEls = abschnitt.querySelectorAll('[data-finder-step]');
    var platz = 0;
    schrittEls.forEach(function (el) {
      var n = parseInt(el.getAttribute('data-finder-step'), 10);
      var sichtbar = reihenfolge.indexOf(n) !== -1;
      if (!sichtbar) { el.hidden = true; return; }
      platz++;
      var zahl = el.querySelector('.finder__num');
      if (zahl) zahl.textContent = platz;
      /* Der offene Schritt ist immer der aktuelle — sonst pulsiert beim
         „ändern“ eines beantworteten Schritts gleichzeitig der nächste. */
      var istAktiv = (n === offen) || (offen == null && n === aktuell);
      el.setAttribute('data-state', istAktiv ? 'current' : (werte[n] ? 'done' : 'todo'));
    });

    if (elNum) elNum.textContent = Math.min(erledigt + 1, gesamt);
    var label = elProgress.querySelector('.finder__progress-label');
    if (label) {
      label.innerHTML = erledigt >= gesamt
        ? 'Fertig'
        : 'Frage <strong data-finder-step-num>' + Math.min(erledigt + 1, gesamt) + '</strong> von ' + gesamt;
    }
    elProgress.classList.toggle('is-done', erledigt >= gesamt);
    if (elState) {
      elState.textContent = erledigt >= gesamt
        ? 'fertig — dein LED-Band steht fest'
        : erledigt === 0 ? 'gerade gestartet' : erledigt + ' von ' + gesamt + ' beantwortet';
    }

    var missing = abschnitt.querySelector('[data-finder-missing]');
    if (missing) {
      /* Nicht `offen` nennen — das ist der aktuell aufgeklappte Schritt. */
      var fehltListe = [];
      if (!ort) fehltListe.push('Einsatzort');
      if (!laenge) fehltListe.push('Wunschlänge');
      else if (!genau) fehltListe.push('Genauigkeit');
      if (!licht) fehltListe.push('Lichtfarbe');
      if (brauchtWeissF && !weiss) fehltListe.push('Weißton');
      if (!stark) fehltListe.push('Helligkeit');
      var angefangen = !!(ort || laenge || licht);
      missing.hidden = !(angefangen && fehltListe.length > 0);
      missing.textContent = fehltListe.length ? 'Fehlt noch: ' + fehltListe.join(' · ') : '';
    }
  }

  function stepEl(nr) { return abschnitt.querySelector('[data-finder-step="' + nr + '"]'); }

  function wertVon(nr) {
    if (nr === 1) return ort;
    if (nr === 2) return (laenge && genau) ? laenge : null;
    if (nr === 3) return licht;
    if (nr === 4) return weiss;
    if (nr === 5) return stark;
    return null;
  }

  /* Beschriftung der Zusammenfassung: Titel der gewählten Kachel */
  function antwortText(nr) {
    if (nr === 2) {
      if (!laenge) return '';
      var plan = voltPlan();
      var g = genau === 'exakt' ? 'exakt' : '±5 cm';
      return laengeText(laenge) + ' · ' + (plan ? plan.text : '') + ' · ' + g;
    }
    var step = stepEl(nr);
    if (!step) return '';
    var b = step.querySelector('[aria-pressed="true"]');
    if (!b) return '';
    var t = b.querySelector('.finder__opt-title') || b;
    return String(t.textContent).replace(/\s+/g, ' ').trim();
  }

  /* Nächster Schritt ohne Antwort — Schritt 4 gibt es nur bei RGB+W */
  function naechsterOffen() {
    var reihe = [1, 2, 3];
    if (licht === 'rgbw') reihe.push(4);
    reihe.push(5);
    for (var i = 0; i < reihe.length; i++) {
      if (!wertVon(reihe[i])) return reihe[i];
    }
    return null;
  }

  function baueZusammenfassungen() {
    [1, 2, 3, 4, 5].forEach(function (nr) {
      var step = stepEl(nr);
      if (!step || step.querySelector('[data-finder-edit]')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'finder__sum';
      b.setAttribute('data-finder-edit', String(nr));
      b.innerHTML = '<span class="finder__sum-wert"></span><span class="finder__sum-edit">ändern</span>';
      b.addEventListener('click', function () {
        offen = nr;
        zeige();
        step.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      var q = step.querySelector('.finder__q');
      if (q && q.nextSibling) step.insertBefore(b, q.nextSibling);
      else step.appendChild(b);
    });
  }

  /* Höhe des offenen Schritts steuern.
     Beim Öffnen wird die gemessene Höhe gesetzt (damit die Animation die
     volle Strecke läuft), danach auf `none` freigegeben — sonst schneidet
     ein zu früh gemessener Wert die letzten Kacheln ab (bei den Lichtfarben
     fehlten 38 px). Beim Schließen umgekehrt: Höhe fixieren, Reflow
     erzwingen, dann auf 0 laufen lassen. */
  var hoeheErsterLauf = true;

  function passeOptsHoehe() {
    abschnitt.querySelectorAll('[data-finder-step]').forEach(function (st) {
      var o = st.querySelector('.finder__opts');
      if (!o) return;
      var istOffen = st.classList.contains('is-open');

      if (istOffen) {
        if (hoeheErsterLauf) {
          o.style.maxHeight = 'none';
          o.__offen = true;
          return;
        }
        if (!o.__offen) {
          o.__offen = true;
          o.style.maxHeight = o.scrollHeight + 'px';
          o.addEventListener('transitionend', function frei(ev) {
            if (ev.target !== o || ev.propertyName !== 'max-height') return;
            o.removeEventListener('transitionend', frei);
            if (st.classList.contains('is-open')) o.style.maxHeight = 'none';
          });
        } else {
          o.style.maxHeight = 'none';
        }
      } else if (o.__offen || o.style.maxHeight === 'none') {
        o.__offen = false;
        var h = o.scrollHeight;
        o.style.maxHeight = h + 'px';
        void o.offsetHeight;
        o.style.maxHeight = '';
      }
    });
    hoeheErsterLauf = false;
  }

  /* Die aktuelle Frage muss nach jedem Weiterschalten vollständig zu sehen
     sein — auf dem Handy liegt sie sonst schnell unter dem Falz oder unter
     dem klebenden Kopf. Gemessen wird erst nach dem Auf-/Zuklappen, weil
     sich die Position während der Animation noch verschiebt. */
  var blickTimer = null;
  var letzteNutzerScrollung = 0;

  function halteFrageImBlick() {
    if (offen == null) return;
    var zs = stepEl(offen);
    if (!zs) return;
    var frage = zs.querySelector('.finder__q') || zs;
    var rf = frage.getBoundingClientRect();
    var kopfEl = document.querySelector('.header');
    var kopfH = kopfEl ? kopfEl.getBoundingClientRect().height : 0;
    var oben = kopfH + 12;
    var unten = window.innerHeight - 10;
    /* Steht die Frage zwar im Bild, aber im unteren Drittel, sieht man die
       Antworten darunter nicht — dann ebenfalls nach oben holen. */
    var zuTief = rf.top > window.innerHeight * 0.55;
    if (rf.top >= oben && rf.bottom <= unten && !zuTief) return;
    if (Date.now() - letzteNutzerScrollung < 700) return; // nicht dazwischenfunken
    var ziel = Math.max(0, window.scrollY + rf.top - oben);
    window.scrollTo({ top: ziel, behavior: 'smooth' });
  }

  /* Eigene Scroll-Animation: das native 'smooth' saust bei langen Strecken
     in ~300 ms durch und wirkt wie ein Sprung. Hier bestimmt die Entfernung
     die Dauer, mit weichem Anlauf und Auslauf. */
  var scrollLauf = 0;
  var weichAktiv = 0;
  function weichZu(zielY, dauer) {
    var startY = window.scrollY;
    var dist = zielY - startY;
    if (Math.abs(dist) < 4) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, zielY);
      return;
    }
    /* Das Theme setzt html { scroll-behavior: smooth }. Dann wird jedes
       scrollTo() im Frame selbst noch einmal weichgezogen — die Animation
       kriecht hinterher. Für die Dauer der eigenen Animation abschalten. */
    var root = document.documentElement;
    weichAktiv++;
    root.style.scrollBehavior = 'auto';
    var start = performance.now();
    var lauf = ++scrollLauf;
    function fertig() {
      weichAktiv = Math.max(0, weichAktiv - 1);
      if (!weichAktiv) root.style.scrollBehavior = '';
    }
    function schritt(jetzt) {
      if (lauf !== scrollLauf) { fertig(); return; }
      var t = Math.min(1, (jetzt - start) / dauer);
      var e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      window.scrollTo(0, Math.round(startY + dist * e));
      if (t < 1) window.requestAnimationFrame(schritt);
      else fertig();
    }
    window.requestAnimationFrame(schritt);
  }

  ['wheel', 'touchmove'].forEach(function (ev) {
    window.addEventListener(ev, function () {
      letzteNutzerScrollung = Date.now();
      scrollLauf++;              // laufende Scroll-Animation abbrechen
    }, { passive: true });
  });

  function frageImBlickHalten() {
    var sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.clearTimeout(blickTimer);
    if (!sanft) { halteFrageImBlick(); return; }
    /* 480 ms = Ende des Aufklappens, 780 ms fängt spätes Nachrutschen
       (Schrift, Umbrüche) noch ab. */
    window.setTimeout(halteFrageImBlick, 480);
    blickTimer = window.setTimeout(halteFrageImBlick, 780);
  }

  /* Ab 1024 px steht genug Platz zur Verfügung: Dann bleiben alle Fragen
     offen (kein Akkordeon), es wird nicht zwischen den Fragen gescrollt und
     erst das Ergebnis holt die Seite zu sich. Mobil bleibt der Weg Schritt
     für Schritt. */
  function istDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  function zeige() {
    var desktop = istDesktop();
    var brauchtWeiss = (licht === 'rgbw');
    var stepWeiss = abschnitt.querySelector('[data-finder-step="4"]');
    var stepStark = abschnitt.querySelector('[data-finder-step="5"]');
    if (stepWeiss) stepWeiss.hidden = !brauchtWeiss;
    if (stepStark) stepStark.hidden = false;

    abschnitt.querySelector('[data-finder-step="1"]').classList.toggle('is-done', !!ort);
    abschnitt.querySelector('[data-finder-step="2"]').classList.toggle('is-done', !!laenge && !!genau);
    abschnitt.querySelector('[data-finder-step="3"]').classList.toggle('is-done', !!licht);
    if (stepWeiss) stepWeiss.classList.toggle('is-done', brauchtWeiss && !!weiss);
    if (stepStark) stepStark.classList.toggle('is-done', !!stark);

    markiereLicht();
    markiereWeiss();
    zeigeExaktWarnung();
    zeigeLeerWarnung();
    fortschritt();

    /* Akkordeon: genau ein Schritt offen, beantwortete zeigen ihre Antwort
       als Zeile, spätere sind gesperrt. Erst wenn alles beantwortet ist,
       stehen alle Zeilen zusammen mit dem Ergebnis da. */
    if (offen === 4 && licht !== 'rgbw') offen = naechsterOffen();
    /* Sichtbare Nummerierung: Schritt 4 (Weiß) fällt bei einfarbig weg,
       sonst würde die Liste 1, 2, 3, 5 zählen. */
    var reihe = [1, 2, 3];
    if (licht === 'rgbw') reihe.push(4);
    reihe.push(5);
    reihe.forEach(function (nr, idx) {
      var st = stepEl(nr), num = st && st.querySelector('.finder__num');
      if (num) num.textContent = String(idx + 1);
    });
    [1, 2, 3, 4, 5].forEach(function (nr) {
      var step = stepEl(nr);
      if (!step) return;
      var wert = wertVon(nr);
      /* Desktop: Der nächste Schritt öffnet sich, sobald die Frage davor
         beantwortet ist — beantwortete Schritte bleiben offen. Mobil klappt
         nur der aktuelle Schritt, die anderen werden zur Zeile. */
      var istOffen = desktop ? (!!wert || offen === nr) : (offen === nr);
      step.classList.toggle('is-open', istOffen);
      step.classList.toggle('is-collapsed', !desktop && !istOffen && !!wert);
      /* Auch auf dem Desktop bleiben noch nicht erreichte Schritte zu —
         sonst stehen alle Kacheln von Anfang an offen. */
      step.classList.toggle('is-locked', !istOffen && !wert);
      var sum = step.querySelector('[data-finder-edit]');
      if (sum) {
        var ziel = sum.querySelector('.finder__sum-wert');
        if (ziel) ziel.textContent = wert ? antwortText(nr) : '';
      }
      Array.prototype.forEach.call(step.querySelectorAll('.finder__opts button'), function (b) {
        b.disabled = !desktop && !istOffen;
      });
    });
    passeOptsHoehe();

    /* Bei geänderter Breite bricht der Text anders um — die gemerkte
       Höhe des offenen Schritts würde sonst abschneiden. */
    if (!abschnitt.__hoeheLauscht) {
      abschnitt.__hoeheLauscht = true;
      var hoeheTimer = null;
      window.addEventListener('resize', function () {
        window.clearTimeout(hoeheTimer);
        hoeheTimer = window.setTimeout(passeOptsHoehe, 120);
      });
    }

    if (offen !== letzterOffen) {
      letzterOffen = offen;
      if (!desktop) frageImBlickHalten();
    }

    if (!ort || !laenge || !genau || !licht) return;
    if (brauchtWeiss && !weiss) return;
    if (!stark) return;

    var treffer = finde();
    var p = treffer.produkt;
    if (!p) {
      /* Es gibt für diese Kombination kein LED-Band. Vorher passierte hier
         nichts — der Kunde sah seine Antworten, aber kein Ergebnis und
         keinen Grund. */
      result.hidden = true;
      var keinTreffer = abschnitt.querySelector('[data-finder-missing]');
      if (keinTreffer) {
        keinTreffer.hidden = false;
        keinTreffer.textContent = 'Für diese Kombination haben wir kein LED-Band ab Lager. Schreib uns — Sonderlösungen fertigen wir auf Anfrage.';
      }
      return;
    }

    var typ = typVon(p);
    elTitel.textContent = p.title;
    elText.textContent = typ === 'CCT'
      ? 'Lichtfarbe per Fernbedienung von warm bis kalt — du entscheidest später.'
      : (typ === 'RGB' || typ === 'RGBW')
        ? 'Jede Farbe inklusive Weiß — steuerbar per App oder Fernbedienung.'
        : 'Durchgehende Lichtlinie ohne sichtbare Punkte, zugeschnitten auf deine Länge.';
    elImg.src = p.image;
    elImg.alt = p.title;

    /* Lichtleiste unter dem Bild — dieselbe Optik wie auf den Produktkarten.
       RGB+W und RGB+CCT bekommen zwei getrennte Leisten (80 % RGB, 20 % Weiß/CCT). */
    if (elLight) {
      var ctRoh = String(p.ct || '');
      var kMatch = ctRoh.match(/(\d{4})/);
      var kNum = kMatch ? parseInt(kMatch[1], 10) : 0;
      var wFarbe = kNum && kNum <= 2900 ? '#FFB877'
        : (kNum && kNum <= 3500 ? '#FFCE9E'
        : (kNum >= 5600 ? '#DDEBFF' : '#FFF0DA'));
      var istCctRgb = typ === 'RGBW' && ctRoh.indexOf('-') > -1;
      var leiste;
      if (typ === 'RGBW') {
        leiste = '<div class="card__duo light-bar--product">' +
          '<span class="card__duo-rgb"></span>' +
          '<span class="card__duo-w' + (istCctRgb ? ' card__duo-w--cct' : '') + '"' +
          (istCctRgb ? '' : ' style="--w:' + wFarbe + '"') + '></span></div>' +
          '<p class="card__duo-label light-bar__label"><span>RGB</span><span>' +
          (istCctRgb ? 'CCT' : (kNum ? kNum + 'K' : 'Weiß')) + '</span></p>';
      } else {
        /* Auch einfache Leisten beschriften — links Name, rechts Kelvin. */
        var kText = '';
        if (kNum) {
          kText = ctRoh.indexOf('-') > -1
            ? ctRoh.replace(/\s*[Kk]$/, '').replace('-', '\u2013') + ' K'
            : kNum + ' K';
        }
        var lfName = typ === 'RGB' ? 'RGB'
          : (kNum >= 5800 ? 'Kaltweiß'
          : (kNum >= 3800 ? 'Neutralweiß'
          : (kNum >= 2400 ? 'Warmweiß'
          : (kNum > 0 ? 'Extra Warm' : 'Einstellbar'))));
        var leer = typ === 'RGB';
        var lsw = typ === 'RGB'
          ? 'linear-gradient(90deg,#FF6B6B,#6BCB77,#4D96FF)'
          : (typ === 'CCT' ? 'linear-gradient(90deg,#FFB877,#FFCE9E,#FFF0DA,#DDEBFF)' : wFarbe);
        leiste = '<span class="card__light light-bar--product" style="--sw:' + lsw + '"></span>' +
          '<p class="card__duo-label light-bar__label"><span>' + (typ === 'CCT' ? 'Einstellbar' : lfName) + '</span>' +
          '<span>' + (leer ? '' : kText) + '</span></p>';
      }
      elLight.innerHTML = leiste;
    }

    /* Preise kommen bereits deutsch formatiert aus Liquid ("1.367,80") —
       nicht selbst umformatieren, sonst wird daraus "1,367,80". */
    var preis = p.price1Text || p.price;
    elPreis.textContent = preis + ' €';
    /* 48-V-Bänder gibt es nur in 5-m- und 15-m-Gebinden — dann darf dort
       nicht "1 m ab" stehen. */
    if (elPreisLabel) elPreisLabel.textContent = p.price1 ? 'ab 1 m' : 'ab ' + (p.ab || 'Gebinde');
    var elPreisNote = abschnitt.querySelector('[data-finder-price-note]');
    if (elPreisNote) elPreisNote.textContent = p.price1 ? 'pro Meter, inkl. 19 % MwSt.' : 'inkl. 19 % MwSt.';
    /* Gewählte Lichtfarbe mitgeben, damit die Produktseite sie vorwählt.
       Die Option heißt je Produkt anders („2700K", „4000K", …) — deshalb
       wird der rohe Optionswert aus den Finderdaten genommen. */
    var farbeWert = null;
    if (/^\d{4}$/.test(String(licht || ''))) {
      var rohFarben = p.farben || [];
      for (var fi = 0; fi < rohFarben.length; fi++) {
        if (String(rohFarben[fi]).replace(/[^0-9]/g, '') === String(licht)) { farbeWert = rohFarben[fi]; break; }
      }
      if (!farbeWert && licht === '6500') {
        for (var fj = 0; fj < rohFarben.length; fj++) {
          if (String(rohFarben[fj]).replace(/[^0-9]/g, '') === '6000') { farbeWert = rohFarben[fj]; break; }
        }
      }
    }
    /* Länge mitgeben — und zwar die Zuschnittlänge, die dieses Band wirklich
       hergibt, nicht die Wunschzahl. Sonst rastet der Regler auf einen Wert,
       der nicht zur Schnittteilung passt. */
    var params = [];
    if (farbeWert) params.push('farbe=' + encodeURIComponent(farbeWert));
    if (laenge) {
      var zs = zuschnitt(p, laenge * 100);
      var cmWert = zs && zs.moeglich ? zs.ist : Math.round(laenge * 100 * 100) / 100;
      params.push('laenge=' + encodeURIComponent(String(cmWert)));
    }
    elLink.href = p.url + (params.length ? '?' + params.join('&') : '');

    var hinweis = treffer.hinweis || naeherung[licht];

    if (licht === '6500' && p.watt > 13) {
      hinweis = 'Tageslichtweiß 6500 K gibt es nur in der hellen Variante (15 W/m). Eine gemütlichere Stufe mit 6500 K führen wir nicht.';
    }
    if (licht === 'rgb' && typ === 'RGBW') {
      hinweis = 'Ein reines Farbband ohne Weiß führen wir nicht. Dieses LED-Band hat zusätzlich einen Weißton — steuerbar wie eine eigene Farbe.';
    }
    if ((licht === 'cct' || licht === 'rgbcct') && !naeherung[licht] && !hinweis) {
      hinweis = 'Das CCT-Band gibt es in einer Leistungsstufe (15 W/m). Die Helligkeitswahl ändert hier nichts.';
    }
    if (licht === 'rgbw' && weiss && typ === 'RGBW' && kelvinVon(p).indexOf(weiss) === -1) {
      var vorhanden = kelvinVon(p).filter(function (k) { return k !== '6500' || kelvinVon(p).length === 1; });
      hinweis = 'Dieses LED-Band gibt es nur mit ' + (vorhanden.join(' / ') || 'einem') + ' K Weiß. Andere Weißtöne führen wir derzeit nicht — frag uns nach einer Sonderlösung.';
    }

    var altHinweis = abschnitt.querySelector('[data-finder-note]');
    if (!altHinweis && elFacts && elFacts.parentElement) {
      altHinweis = document.createElement('p');
      altHinweis.className = 'finder__result-note';
      altHinweis.setAttribute('data-finder-note', '');
      elFacts.parentElement.insertBefore(altHinweis, elFacts.nextSibling);
    }
    if (altHinweis) {
      altHinweis.textContent = hinweis || '';
      altHinweis.hidden = !hinweis;
    }

    var farbenListe = kelvinVon(p);
    var farbenText = typ === 'CCT' ? 'Warm bis kalt (2700–6500 K)'
      : typ === 'RGB' ? 'Alle Farben'
      : typ === 'RGBW' ? 'Alle Farben + Weiß'
      : farbenListe.map(function (k) { return k + ' K'; }).join(' · ');
    if (typ === 'EINFARBIG' && !farbenListe.length) farbenText = 'Eine Lichtfarbe';

    elFacts.innerHTML = '';
    [
      voltVon(p) + ' V',
      laenge ? 'Für ' + laengeText(laenge) : '',
      zuschnittFact(p),
      (function () {
        var ip = String(p.ip || 'IP20').toUpperCase();
        var num = parseInt(ip.replace(/[^0-9]/g, ''), 10) || 20;
        if (num >= 67) return 'Wasserdicht (' + ip + ')';
        if (num >= 44) return 'Spritzwassergeschützt (' + ip + ')';
        return 'Für trockene Räume (IP20)';
      })(),
      farbenText,
      (p.lumen ? String(p.lumen).replace('-', '–') + ' lm/m'
               : (p.watt ? p.watt + ' W/m' : ''))
    ].filter(function (t) { return !!t; }).forEach(function (t) {
      var li = document.createElement('li');
      li.textContent = t;
      elFacts.appendChild(li);
    });

    if (elAlts && elAltsList) {
      var alle = treffer.weitere || [];
      if (p.handle !== letztesProdukt) { altsOffen = false; letztesProdukt = p.handle; }
      /* Höchstens drei Alternativen — mehr überfordert an dieser Stelle. */
      var sichtbar = alle.slice(0, 3);
      elAltsList.innerHTML = '';
      sichtbar.forEach(function (a) {
        var li = document.createElement('li');
        var link = document.createElement('a');
        link.href = a.url;
        if (a.image) {
          var bild = document.createElement('img');
          bild.src = a.image;
          bild.alt = '';
          bild.width = 34;
          bild.height = 34;
          bild.loading = 'lazy';
          link.appendChild(bild);
        }
        var name = document.createElement('span');
        name.className = 'finder__alts-name';
        /* Serie nur wenn sie abweicht, Spannung/Schutzart nur wenn anders —
           Leistung und Lichtfarbe bleiben immer stehen. */
        var teileA = String(a.title).replace(/^LED (COB|SMD) /, '').split(' · ');
        var teileP = String(p.title).replace(/^LED (COB|SMD) /, '').split(' · ');
        var rest = teileA.slice(1).filter(function (t) {
          var istNorm = /^(24V|48V)$/i.test(t) || /^IP\d+$/i.test(t);
          return istNorm ? teileP.indexOf(t) === -1 : true;
        });
        name.textContent = (teileA[0] !== teileP[0] ? teileA[0] + ' · ' : '') + rest.join(' · ');
        var preisAlt = document.createElement('span');
        preisAlt.className = 'finder__alts-price';
        preisAlt.textContent = (a.price1Text ? '1 m · ' : (a.ab || 'Gebinde') + ' · ') +
          (a.price1Text || a.price) + ' €';
        link.appendChild(name);
        link.appendChild(preisAlt);
        li.appendChild(link);
        elAltsList.appendChild(li);
      });
      var altsTitel = elAlts.querySelector('.finder__alts-title');
      if (altsTitel) {
        altsTitel.textContent = sichtbar.length === 1 ? 'Alternative' : 'Alternativen';
      }
      elAlts.hidden = !sichtbar.length;
    }

    /* Nur beim ersten Erscheinen zur Karte springen. Ändert der Kunde später
       eine Antwort, bleibt er an der Stelle, die er gerade bearbeitet. */
    var ergebnisWarVersteckt = result.hidden;
    result.hidden = false;
    /* Karte an den Anfang holen, nicht „nearest“: Bei block:'nearest' bleibt
       der obere Rand (Produktbild) unter dem klebenden Header hängen und die
       Karte wirkt oben abgeschnitten. Gemessen wird erst, wenn der letzte
       Schritt zugeklappt ist — vorher liegt die Karte noch ~200 px tiefer
       und landet nach der Animation über dem Viewport. */
    function holeErgebnis(nurKorrektur) {
      if (offen != null) return;            // gerade wird noch ein Schritt bearbeitet
      var kopfR = document.querySelector('.header');
      var kopfHR = kopfR ? kopfR.getBoundingClientRect().height : 0;
      /* Layout-Position statt getBoundingClientRect: Die Einblend-Animation
         verschiebt die Karte gerade um ein paar Pixel nach oben, sonst landet
         der Sprung entsprechend zu hoch. */
      var absTop = 0, el = result;
      while (el) { absTop += el.offsetTop; el = el.offsetParent; }
      var zielY = Math.max(0, absTop - (kopfHR + 14));
      var diff = zielY - window.scrollY;
      if (Math.abs(diff) < (nurKorrektur ? 60 : 4)) return;
      /* Dauer nach Entfernung: kurze Wege ruhig, lange Wege nicht hektisch. */
      weichZu(zielY, Math.min(950, Math.max(520, Math.abs(diff) * 0.55)));
    }
    if (offen == null && ergebnisWarVersteckt) {
      /* Karte einblenden … */
      result.classList.remove('is-entering');
      void result.offsetWidth;
      result.classList.add('is-entering');
      /* … und erst danach fahren. Mobil klappt der letzte Schritt noch zu
         (380 ms), deshalb dort später messen. */
      window.clearTimeout(blickTimer);
      window.setTimeout(function () { holeErgebnis(false); }, desktop ? 170 : 430);
      blickTimer = window.setTimeout(function () { holeErgebnis(true); }, 1150);
    }
  }

  /* Info-Tooltip: erst sichtbar schalten, dann messen und im Viewport
     halten. Vorher lief die 330-px-Box auf schmalen Displays über den Rand. */
  function platziereTip(el) {
    var tip = el.querySelector('.finder__info-tip');
    if (!tip) return;
    el.classList.add('is-open');
    requestAnimationFrame(function () {
      var r = el.getBoundingClientRect();
      var b = tip.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      var vh = document.documentElement.clientHeight;
      var rand = 12;
      var links = Math.min(Math.max(rand, r.left + r.width / 2 - b.width / 2), vw - b.width - rand);
      var oben = r.bottom + 10;
      if (oben + b.height > vh - rand) {
        oben = Math.max(rand, r.top - b.height - 10);
      } else if (vw < 640 && r.top - b.height - 10 >= rand) {
        /* Auf dem Handy sonst über der ersten Antwortkachel — lieber über der Frage */
        oben = r.top - b.height - 10;
      }
      /* In Koordinaten des Icons umrechnen — offsetParent ist .finder__info */
      tip.style.left = Math.round(links - r.left) + 'px';
      tip.style.top = Math.round(oben - r.top) + 'px';
    });
  }

  function schliesseTips() {
    abschnitt.querySelectorAll('.finder__info.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
  }

  abschnitt.querySelectorAll('.finder__info').forEach(function (el) {
    var perMaus = false;
    el.addEventListener('pointerenter', function (ev) {
      perMaus = ev.pointerType === 'mouse';
      if (perMaus) platziereTip(el);
    });
    el.addEventListener('mouseenter', function () { if (perMaus) platziereTip(el); });
    el.addEventListener('mouseleave', function () { if (perMaus) el.classList.remove('is-open'); });
    el.addEventListener('pointerleave', function (ev) {
      if (ev.pointerType === 'mouse') el.classList.remove('is-open');
    });
    el.addEventListener('focus', function () { platziereTip(el); });
    el.addEventListener('blur', function () { el.classList.remove('is-open'); });
    el.addEventListener('click', function (ev) {
      ev.preventDefault();
      /* Desktop: Hover hat schon geöffnet — Klick darf nicht schließen.
         Touch: erster Tipp öffnet, zweiter schließt. */
      if (perMaus) return;
      if (el.classList.contains('is-open')) { el.classList.remove('is-open'); }
      else { platziereTip(el); }
    });
  });
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest || !ev.target.closest('.finder__info')) schliesseTips();
  });
  window.addEventListener('scroll', schliesseTips, { passive: true });

  markiereWeiss();

  abschnitt.querySelectorAll('[data-finder-ort]').forEach(function (b) {
    b.addEventListener('click', function () {
      waehle(b); ort = b.getAttribute('data-finder-ort'); offen = naechsterOffen(); zeige();
    });
  });
  var laengeFeld = abschnitt.querySelector('[data-finder-laenge]');
  var laengeHinweis = abschnitt.querySelector('[data-finder-laenge-hinweis]');

  function laengeHinweisText(n) {
    if (!n) return 'Bis 5 m empfehlen wir 24 V, ab 5 m 48 V. Die passende Spannung wählen wir automatisch.';
    if (n <= 5) return laengeText(n) + ' → 24 V, ein Netzteil und ein Einspeisepunkt.';
    if (n <= 10) return laengeText(n) + ' → 48 V für den ganzen Lauf an einem Netzteil.';
    return laengeText(n) + ' → 48 V, je nach Rolle bis 30 m am Stück — ohne zweiten Einspeisepunkt.';
  }
  function setzeLaenge(n, ausFeld) {
    laenge = n;
    if (laengeHinweis) laengeHinweis.textContent = laengeHinweisText(n);
    if (!ausFeld && laengeFeld) laengeFeld.value = n == null ? '' : String(n).replace('.', ',');
    if (laengeFeld) laengeFeld.classList.remove('is-fehler');
    abschnitt.querySelectorAll('[data-finder-laenge-chip]').forEach(function (c) {
      c.setAttribute('aria-pressed', String(Number(c.getAttribute('data-finder-laenge-chip')) === n));
      c.classList.toggle('is-aktiv', Number(c.getAttribute('data-finder-laenge-chip')) === n);
    });
  }
  function leseLaenge() {
    if (!laengeFeld) return null;
    var roh = String(laengeFeld.value).replace(',', '.').replace(/[^\d.]/g, '');
    var n = parseFloat(roh);
    if (isNaN(n) || n <= 0) return null;
    return Math.round(n * 100) / 100;     /* auf den Zentimeter */
  }
  var exaktWarnung = abschnitt.querySelector('[data-finder-exakt-warnung]');
  var exaktText = abschnitt.querySelector('[data-finder-exakt-text]');

  /* Gibt es für Ort, Spannung und Länge überhaupt ein Band, das exakt passt?
     Wenn nicht, sagen wir es sofort in Schritt 2 — sonst läuft der Kunde in
     einen leeren Lichtfarben-Schritt. */
  function exaktMoeglich() {
    if (!ort || !laenge) return true;
    var plan = voltPlan();
    return daten.some(function (p) {
      return ipKlasse(p) === ort && voltPasst(p, plan) && zuschnittPasst(p, laenge * 100, 'exakt');
    });
  }
  function naechsteLaengen() {
    var plan = voltPlan();
    var treffer = [];
    daten.forEach(function (p) {
      if (ipKlasse(p) !== ort || !voltPasst(p, plan)) return;
      var z = zuschnitt(p, laenge * 100);
      if (z && z.moeglich && Math.abs(z.diff) <= 5) treffer.push(z.ist);
    });
    treffer.sort(function (a, b) { return Math.abs(a - laenge * 100) - Math.abs(b - laenge * 100); });
    var out = [];
    treffer.forEach(function (v) { if (out.indexOf(v) === -1 && out.length < 2) out.push(v); });
    return out;
  }
  var empfohlenBadge = abschnitt.querySelector('[data-finder-empfohlen]');
  var toleranzKachel = abschnitt.querySelector('[data-finder-genau="toleranz"]');

  function zeigeExaktWarnung() {
    /* Die ±5-cm-Kachel hervorheben, sobald sie der einzige Weg zum Ergebnis ist —
       sonst übersieht man sie zwischen den grauen Kacheln. */
    var nurToleranz = !!(ort && laenge && genau !== 'toleranz' && !exaktMoeglich());
    if (empfohlenBadge) empfohlenBadge.hidden = !nurToleranz;
    if (toleranzKachel) toleranzKachel.classList.toggle('is-empfohlen', nurToleranz);
    if (!exaktWarnung) return;
    var zeigen = !!(ort && laenge && genau === 'exakt' && !exaktMoeglich());
    exaktWarnung.hidden = !zeigen;
    if (!zeigen || !exaktText) return;
    var nah = naechsteLaengen();
    exaktText.textContent = 'Kein Band trifft ' + laengeText(laenge) + ' exakt' +
      (nah.length ? ' — das Schnittraster erlaubt ' + nah.map(cmText).join(' oder ') : '') +
      '. Mit ±5 cm findest du passende Bänder.';
  }
  var exaktBtn = abschnitt.querySelector('[data-finder-exakt-toleranz]');
  if (exaktBtn) exaktBtn.addEventListener('click', function () {
    setzeGenau('toleranz');
    markiereLicht(); markiereWeiss();
    zeige();
  });

  var genauHinweis = abschnitt.querySelector('[data-finder-genau-hinweis]');
  var GENAU_STANDARD = genauHinweis ? genauHinweis.textContent : '';
  function setzeGenau(wert) {
    genau = wert;
    abschnitt.querySelectorAll('[data-finder-genau]').forEach(function (b) {
      var an = b.getAttribute('data-finder-genau') === wert;
      b.setAttribute('aria-pressed', an ? 'true' : 'false');
    });
    if (genauHinweis) {
      genauHinweis.textContent = wert === 'exakt'
        ? 'Wir zeigen nur Bänder, deren Schnittraster deine Wunschlänge auf den halben Zentimeter trifft.'
        : (wert === 'toleranz'
          ? 'Wir zeigen Bänder, die deine Wunschlänge auf ±5 cm treffen. Die tatsächliche Länge steht im Ergebnis.'
          : GENAU_STANDARD);
    }
  }
  abschnitt.querySelectorAll('[data-finder-genau]').forEach(function (b) {
    b.addEventListener('click', function () {
      var wert = b.getAttribute('data-finder-genau');
      setzeGenau(wert);
      markiereLicht(); markiereWeiss();
      /* Ist „exakt" für diese Länge nicht lieferbar, bleibt Frage 2 offen —
         sonst springt die Ansicht weiter und der Hinweis mit dem Ausweg
         steht außerhalb des Bildes. */
      offen = (wert === 'exakt' && laenge && !exaktMoeglich()) ? 2 : naechsterOffen();
      zeige();
    });
  });

  if (laengeFeld) {
    laengeFeld.addEventListener('input', function () {
      var n = leseLaenge();
      if (n == null) return;
      var zuLang = n > 30;
      if (zuLang) {
        n = 30;
        /* Feld auf den gekappten Wert ziehen — sonst steht dort weiter „40",
           während intern mit 30 m gerechnet wird. */
        if (laengeFeld.value !== '30') laengeFeld.value = '30';
      }
      if (n !== laenge) {
        setzeLaenge(n, true);
        markiereLicht(); markiereWeiss(); zeige();
      }
      laengeFeld.classList.toggle('is-fehler', zuLang);
      if (laengeHinweis) {
        laengeHinweis.textContent = zuLang
          ? 'Am Stück gehen höchstens 30 m. Darüber teilen wir in mehrere Einspeisungen — frag uns nach der Aufteilung.'
          : laengeHinweisText(n);
      }
    });
    laengeFeld.addEventListener('change', function () {
      var n = leseLaenge();
      if (n == null) { laengeFeld.value = laenge ? String(laenge).replace('.', ',') : ''; return; }
      if (n !== laenge) setzeLaenge(n, true);
      offen = naechsterOffen();
      zeige();
    });
  }
  abschnitt.querySelectorAll('[data-finder-laenge-chip]').forEach(function (c) {
    c.addEventListener('click', function () {
      setzeLaenge(Number(c.getAttribute('data-finder-laenge-chip')), false);
      markiereLicht(); markiereWeiss();
      offen = naechsterOffen();
      zeige();
    });
  });

  abschnitt.querySelectorAll('[data-finder-licht]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.classList.contains('is-unavailable')) return;
      waehle(b); licht = b.getAttribute('data-finder-licht'); stark = null; weiss = null;
      offen = naechsterOffen();
      zeige();
    });
  });
  abschnitt.querySelectorAll('[data-finder-weiss]').forEach(function (b) {
    b.addEventListener('click', function () {
      waehle(b); weiss = b.getAttribute('data-finder-weiss'); offen = naechsterOffen(); zeige();
    });
  });
  abschnitt.querySelectorAll('[data-finder-stark]').forEach(function (b) {
    b.addEventListener('click', function () {
      waehle(b); stark = b.getAttribute('data-finder-stark'); offen = naechsterOffen(); zeige();
    });
  });

  var altsToggle = abschnitt.querySelector('[data-finder-alts-toggle]');
  if (altsToggle) altsToggle.addEventListener('click', function () {
    altsOffen = !altsOffen;
    zeige();
  });

  var reset = abschnitt.querySelector('[data-finder-reset]');
  if (reset) reset.addEventListener('click', function () {
    ort = laenge = genau = licht = stark = weiss = null;
    setzeGenau(null);
    if (laengeFeld) { laengeFeld.value = ''; laengeFeld.classList.remove('is-fehler'); }
    if (laengeHinweis) laengeHinweis.textContent = laengeHinweisText(null);
    offen = 1;
    letzterOffen = 1;
    altsOffen = false;
    letztesProdukt = null;
    abschnitt.querySelectorAll('[aria-pressed="true"]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    result.hidden = true;
    var stepWeissR = abschnitt.querySelector('[data-finder-step="4"]');
    if (stepWeissR) stepWeissR.hidden = true;
    var stepStarkR = abschnitt.querySelector('[data-finder-step="5"]');
    if (stepStarkR) stepStarkR.hidden = false;
    abschnitt.querySelectorAll('.finder__step.is-done').forEach(function (el) { el.classList.remove('is-done'); });
    var mReset = abschnitt.querySelector('[data-finder-missing]');
    if (mReset) { mReset.hidden = true; mReset.textContent = ''; }
    fortschritt();
    zeige();
    abschnitt.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  baueZusammenfassungen();
  zeige();

  /* Über die 1024-px-Grenze hinweg (Fenster verkleinern, Tablet drehen)
     muss das Akkordeon neu entschieden werden. */
  var desktopMQ = window.matchMedia('(min-width: 1024px)');
  var warDesktop = desktopMQ.matches;
  function beiBreitenwechsel() {
    if (desktopMQ.matches === warDesktop) return;
    warDesktop = desktopMQ.matches;
    zeige();
  }
  if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', beiBreitenwechsel);
  else if (desktopMQ.addListener) desktopMQ.addListener(beiBreitenwechsel);
  }

  var laeuft = false;
  function fehlerHinweis() {
    abschnitt.classList.add('is-visible');
    if (gestartet || abschnitt.querySelector('.finder__fehler')) return;
    var p = document.createElement('p');
    p.className = 'finder__hint finder__fehler';
    p.innerHTML = 'Der Bandfinder konnte nicht geladen werden. ' +
      '<a href="/collections/led-baender">Alle LED-Bänder ansehen</a>';
    abschnitt.appendChild(p);
  }

  function hole(versuch) {
    fetch('/?view=finder-daten', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (!text) throw new Error('leer');
        var roh = text.trim();
        /* Das Template gibt reines JSON aus; im Theme-Editor kommt HTML
           mit eingebettetem Skript-Tag. Beides muss funktionieren. */
        if (roh.charAt(0) === '[') {
          starte(JSON.parse(roh));
          return;
        }
        var box = document.createElement('div');
        box.innerHTML = text;
        var skript = box.querySelector('[data-finder-data]');
        if (!skript) throw new Error('keine Daten');
        starte(JSON.parse(skript.textContent));
      })
      .catch(function () {
        if (versuch < 2) { setTimeout(function () { hole(versuch + 1); }, 600); }
        else fehlerHinweis();
      });
  }

  function laden() {
    if (laeuft) return;
    laeuft = true;
    /* Sichtbarkeit nicht von den Daten abhängig machen: sonst bleibt der
       ganze Finder unsichtbar, wenn der Abruf scheitert. */
    abschnitt.classList.add('is-visible');
    var inline = document.querySelector('[data-finder-data]');
    if (inline) {
      try { starte(JSON.parse(inline.textContent)); } catch (e) { fehlerHinweis(); }
      return;
    }
    hole(0);
  }

  /* Schon kurz nach dem Laden holen — 4 KB, aber der Finder ist dann sicher
     bereit, bevor jemand bis dorthin scrollt. */
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () { laden(); }, { timeout: 2500 });
  } else {
    setTimeout(laden, 800);
  }
  if ('IntersectionObserver' in window) {
    var nah = new IntersectionObserver(function (e) {
      for (var i = 0; i < e.length; i++) {
        if (e[i].isIntersecting) { nah.disconnect(); laden(); return; }
      }
    }, { rootMargin: '500px 0px' });
    nah.observe(abschnitt);
  }
})();

/* ---------- Konfigurator-Akkordeon ----------
   Eigenes Modul, weil der Konfigurator-Code sehr groß ist und die
   Akkordeon-Logik nur das DOM braucht. Jeder Schritt ist ein <details>;
   sobald eine Auswahl getroffen ist, klappt der nächste auf. */
(function () {
  var root = document.querySelector('.config');
  if (!root) return;

  var schritte = Array.prototype.slice.call(root.querySelectorAll('.config__acc'));
  if (!schritte.length) return;

  function werteSchreiben() {
    schritte.forEach(function (acc) {
      var ausgabe = acc.querySelector('[data-acc-value]');
      if (!ausgabe) return;

      var name = acc.getAttribute('data-acc');
      /* Gateway: Beschriftung und Status setzt gwAktualisieren(), weil sie
         davon abhängen, welcher Controller gewählt ist. */
      if (name === 'gateway') return;
      var aktiv = acc.querySelector('[aria-pressed="true"]');
      var wert = '';

      if (name === 'length') {
        var feld = acc.querySelector('[data-length-input]');
        if (feld && feld.value) wert = String(feld.value).replace('.', ',') + ' cm';
      } else if (name === 'cable') {
        var kabelOut = acc.querySelector('[data-cable-value]');
        var kabelTxt = kabelOut ? kabelOut.textContent.trim() : '';
        if (kabelTxt && kabelTxt !== '—') wert = kabelTxt;
      } else if (name === 'ctrl' || name === 'remote') {
        var wahl = acc.querySelector('input[type="radio"]:checked');
        wert = (wahl && wahl.value) ? (wahl.getAttribute('data-title') || 'Gewählt') : 'Ohne';
      } else if (aktiv) {
        wert = aktiv.textContent.trim();
      }

      ausgabe.textContent = wert;
      /* Bei Radio-Schritten entscheidet markGroups(), ob der Haken sitzt —
         sonst überschreiben sich beide Stellen gegenseitig. */
      if (name !== 'ctrl' && name !== 'remote') {
        acc.classList.toggle('is-done', !!wert);
      }
    });
  }

  function naechster(acc) {
    /* Versteckte Schritte (Gateway, wenn nicht nötig) werden übersprungen —
       sonst springt die Kette ins Leere. */
    var sichtbar = schritte.filter(function (x) { return !x.hidden; });
    var i = sichtbar.indexOf(acc);
    if (i === -1) return;
    acc.open = false;
    /* Wer weitergeht, hat den Schritt bestätigt — auch wenn er die Vorbelegung
       nur übernommen hat. */
    acc.setAttribute('data-touched', '1');
    var folge = sichtbar[i + 1];
    if (folge) {
      folge.open = true;
      var r = folge.getBoundingClientRect();
      if (r.top < 120 || r.bottom > window.innerHeight) {
        folge.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  schritte.forEach(function (acc) {
    /* immer nur ein Schritt offen */
    acc.addEventListener('toggle', function () {
      if (!acc.open) return;
      schritte.forEach(function (andere) {
        if (andere !== acc) andere.open = false;
      });
      /* Der Weg soll sofort mitwandern, wenn ein Schritt auf- oder zugeht —
         toggle feuert vor dem nächsten update(). */
      var cfgRoot = acc.closest('[data-led-config]');
      if (cfgRoot && typeof cfgRoot.__markGroups === 'function') cfgRoot.__markGroups();
    });

    acc.addEventListener('click', function (e) {
      var treffer = e.target.closest('[data-option-value], [data-cable], [data-psu], .ctrl__opt');
      if (!treffer) return;
      acc.setAttribute('data-touched', '1');
      window.setTimeout(function () {
        werteSchreiben();
        naechster(acc);
      }, 80);
    });

    /* Steuerung und Fernbedienung sind Radio-Listen: nach der Wahl soll es
       wie bei Länge und Kabel automatisch zum nächsten Schritt gehen. Ein
       Klick-Listener greift hier nicht, weil die Auswahl im Label steckt. */
    acc.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="ls-ctrl"], input[name="ls-remote"], input[name="ls-gw"]')) return;
      acc.setAttribute('data-touched', '1');
      window.setTimeout(function () {
        werteSchreiben();
        naechster(acc);
      }, 120);
    });
  });

  var slider = root.querySelector('[data-length-slider]');
  var eingabe = root.querySelector('[data-length-input]');
  if (slider) {
    // Der Konfigurator schreibt das cm-Feld in seinem eigenen input-Handler.
    // Ein Tick Verzögerung sorgt dafür, dass die Kopfzeile den neuen Wert liest
    // und nicht den alten (sonst stand dort beim Ziehen noch die Startlänge).
    slider.addEventListener('input', function () { window.setTimeout(werteSchreiben, 0); });
    slider.addEventListener('change', function () {
      werteSchreiben();
      var acc = slider.closest('.config__acc');
      if (acc) window.setTimeout(function () { naechster(acc); }, 150);
    });
  }
  if (eingabe) {
    eingabe.addEventListener('input', werteSchreiben);
    eingabe.addEventListener('change', werteSchreiben);
    /* Nach dem Loslassen rastet der Wert auf die nächste Schnittmarke
       (450 → 450,9). Die Kopfzeile muss das nachziehen, sonst steht dort
       weiter die gerundete Zahl aus dem input-Ereignis. */
    eingabe.addEventListener('blur', werteSchreiben);
  }

  // Kabel-Maßband: beim Loslassen weiter zum Netzteil — genau wie beim
  // Längenregler. Ein reines input-Ereignis würde schon beim Ziehen springen.
  /* Manuelle Eingabe: erst „Bestätigen“ (oder Enter) übernimmt den Wert und
     öffnet den nächsten Schritt. Vorher blieb der Schritt offen und es
     passierte nichts, obwohl die Zahl schon in der Box stand. */
  function bestaetigeEingabe(feld, acc) {
    if (!feld || !acc) return;
    if (!String(feld.value).trim()) { feld.focus(); return; }
    feld.dispatchEvent(new Event('change', { bubbles: true }));
    werteSchreiben();
    naechster(acc);
  }

  var okLaenge = root.querySelector('[data-length-ok]');
  if (eingabe && okLaenge) {
    okLaenge.addEventListener('click', function () {
      bestaetigeEingabe(eingabe, eingabe.closest('.config__acc'));
    });
    eingabe.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); okLaenge.click(); }
    });
  }

  var kabelFeld = root.querySelector('[data-cable-input]');
  var okKabel = root.querySelector('[data-cable-ok]');
  if (kabelFeld && okKabel) {
    okKabel.addEventListener('click', function () {
      bestaetigeEingabe(kabelFeld, kabelFeld.closest('.config__acc'));
    });
    kabelFeld.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); okKabel.click(); }
    });
  }

  var kabelSlider = root.querySelector('[data-cable-slider]');
  if (kabelSlider) {
    kabelSlider.addEventListener('change', function () {
      werteSchreiben();
      var acc = kabelSlider.closest('.config__acc');
      if (acc) window.setTimeout(function () { naechster(acc); }, 150);
    });
  }

  werteSchreiben();
})();

/* ---------- Lichtfarben-Filter auf den Übersichtsseiten ----------
   Die Karten tragen ihre Gruppe als data-licht (warm/neutral/kalt/
   einstellbar/farbe). Gefiltert wird im Browser, damit es ohne App und
   ohne Reload geht; die Auswahl landet als ?licht=… in der URL. */
(function () {
  var box = document.querySelector('[data-lightfilter]');
  if (!box) return;
  var grid = document.querySelector('#produkte .grid');
  if (!grid) return;
  var karten = Array.prototype.slice.call(grid.querySelectorAll('.card[data-licht]'));
  if (!karten.length) return;

  var knoepfe = Array.prototype.slice.call(box.querySelectorAll('[data-licht-filter]'));
  var zaehler = document.querySelector('.collection__count');
  var leer = document.querySelector('[data-licht-leer]');

  function anwenden(wert, still) {
    var sichtbar = 0;
    karten.forEach(function (k) {
      var ok = (wert === 'alle' || k.getAttribute('data-licht') === wert);
      k.hidden = !ok;
      if (ok) sichtbar++;
    });
    knoepfe.forEach(function (b) {
      var aktiv = b.getAttribute('data-licht-filter') === wert;
      b.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      b.classList.toggle('is-active', aktiv);
    });
    if (zaehler) zaehler.textContent = sichtbar + ' Artikel';
    if (leer) leer.hidden = sichtbar > 0;
    if (!still) {
      var u = new URL(window.location.href);
      if (wert === 'alle') u.searchParams.delete('licht');
      else u.searchParams.set('licht', wert);
      window.history.replaceState(null, '', u.toString());
    }
  }

  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-licht-filter]');
    if (!b) return;
    anwenden(b.getAttribute('data-licht-filter'));
  });

  var start = new URL(window.location.href).searchParams.get('licht');
  if (start) anwenden(start, true);
})();
